import React, { useEffect, useState } from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import {
  Card,
  CardBody,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  InputGroup,
  InputGroupText,
  Input,
  Label,
  Form,
  Tooltip,
  Container,
  FormGroup,
  Alert
} from "reactstrap";
import moment from "moment-timezone";
import classnames from "classnames";
import SettingEmailConfig from "./SettingEmailConfig";
import General from "./General";
// import Ressources from "./Ressources";
import { Client, Databases, Query, Account, ID } from "appwrite";
import Notifications from "./Notifications";
import Facturation from "./Facturation";
import IntlTelInput from "react-intl-tel-input";
import getFrenchTag from "../../helpers/local_text_helper";
// slider
import MultiRangeSlider from "multi-range-slider-react";

import languages from "../../CommonData/languages";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import makeAnimated from "react-select/animated";
import notificationData from "../../CommonData/Data/notification";
import { withTranslation } from "react-i18next";
//i18n
// import i18n from "../../i18n";
import Logs from "./Logs";
import {
  createEmployeeFunction,
  createLog,
  formatDate,
  klaviyoUpdateProfile
} from "../../helpers/api_helper";
import UpdatePassword from "./updatePassword";
import ReactFlagsSelect from "react-flags-select";
import { useDispatch, useSelector } from "react-redux";
import { isActivatedAgentStatus } from "../../store/generalState/actions";
import StaticData from "../../static/data";
import AgentCard from "./AgentCard";
import CustomToast from "../../components/Common/customToast/CustomToast";
import IconParkSolidRobotOne from "../../assets/images/icons/IconParkSolidRobotOne";
import MyCustomSwitch from "../../components/Common/MyCustomSwitch";
import aiBehaviorData from "../../CommonData/Data/aiBehavior";
import CalculatorModal from "../../components/Common/CalculatorModal/CalculatorModal";

import usFlag from "../../assets/images/flags/us.png";
import spain from "../../assets/images/flags/spain.png";
import germany from "../../assets/images/flags/germany.png";
import italy from "../../assets/images/flags/italy.png";
import russia from "../../assets/images/flags/russia.png";
import french from "../../assets/images/flags/french.png";
import china from "../../assets/images/flags/china.png";
import japan from "../../assets/images/flags/japan.png";
import portugal from "../../assets/images/flags/portugal.png";
import south_korea from "../../assets/images/flags/south-korea.png";
import { useMixpanel } from "../../Hooks/useMixpanel";
import synibox_chat_logo_1000 from "../../assets/images/companies/img-7.png";
import synibix_icon_buble_chat from "../../assets/images/companies/synibix_icon_buble_chat.png";

import MaaiaChangeStatus from "../../components/Common/MaaiaChangeStatus";
import MaaiaPage from "./MaaiaPage";
import FacebookSettings from "../WhatsApp/FacebookSettings";
import WhatsappSettings from "../WhatsApp/WhatsappSettings";
import BillingPage from "./BillingPage";

const components = {
  DropdownIndicator: null
};

const createOption = (label) => ({
  label,
  value: label
});

const Settings = (props) => {
  document.title = props.t("Settings") + " | Synibox - Smart Assistant";
  const params = useParams();
  const { mixPanelTrack } = useMixpanel();

  const timezones = moment.tz.names();
  const [selectedTimezone, setSelectedTimezone] = useState("");
  // const [btnmenu1, setbtnmenu1] = useState(false);
  // const [btnmenu2, setbtnmenu2] = useState(false);
  // const [selectedOption, setSelectedOption] = useState(props.t("Choisir une langue"));
  const [modal_list, setmodal_list] = useState(false);
  const [addAgentModal, setAddAgentModal] = useState(false);
  const [updateAgentModal, setUpdateAgentModal] = useState(false);
  const [updateEmployeeModal, setUpdateEmployeeModal] = useState(false);
  const [employeeToUpdate, setEmployeeToUpdate] = useState();
  // const [ownerInfos, setOwnerInfos] = useState({});
  const [client_data, setCompanyInfos] = useState(undefined);
  // const [company_employees_data, setCompanyEmployeesData] = useState(undefined);
  const [userInfos, setUserInfos] = useState(undefined);
  const [userPrefs, setUserPrefs] = useState({});
  const [toast, setToast] = useState(false);
  const daysOfWeek = ["week", "week_end"];
  const [tooltip, setTooltip] = useState(false);
  const [numberOfLanguages, setNumberOfLanguages] = useState(0);
  const [show_calculator, showCalculator] = useState(false);

  const onShowCalculator = () => {
    showCalculator(!show_calculator);
  };
  const [timesByDay, setTimesByDay] = useState({
    week: {
      open: 0,
      close: 24
    },
    week_end: {
      open: 0,
      close: 24
    }
  });
  const [fullTime, setFullTime] = useState({ week: true, week_end: true });
  const [formErrors, setFormErrors] = useState({});
  // const [itemStates, setItemStates] = useState([]);
  const [agentSelectedTimezone, setAgentTimezone] = useState("");
  // const [selectedMulti3, setselectedMulti3] = useState(null);
  const [selectLang, setselectLang] = useState("en");
  // const [plans, setPlans] = useState("en");
  const handleTimeChange = (day, field, data) => {
    console.log("timesByDay", timesByDay);
    setTimesByDay((prevState) => {
      return {
        ...prevState,
        // [day]: {
        //     ...prevState[day],
        //     checked: true,
        //     [timeType]: time
        // }

        [day]: {
          ...prevState[day],
          [field]: data,
          open: 0,
          close: 24
        }
      };
    });
  };

  // const changeLanguageAction = async (lang) => {
  //   //set language as i18n
  //   i18n.changeLanguage(lang);
  //   localStorage.setItem("I18N_LANGUAGE", lang);
  //   const new_prefs = userPrefs;
  //   new_prefs["lang"] = lang;
  //   const response = await updateUserPrefs(new_prefs);
  //   setselectLang(lang);

  //   // Émettre un événement personnalisé
  //   const event = new CustomEvent("valeurMiseAJour", { detail: lang });
  //   window.dispatchEvent(event);

  //   // Créer le log
  //   var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //   let logData = {
  //     eventCreatedAt: response?.$createdAt,
  //     author_id: user_id,
  //     company_id: client_data.$id,
  //     new_lang: lang,
  //   };
  //   let logdata = {
  //     event: "lang_updated",
  //     author_id: user_id,
  //     company_id: client_data.$id,
  //     log_data: JSON.stringify(logData),
  //   };
  //   createLog(logdata, mixPanelTrack);
  // };
  const languageStore = [
    { name: "Français", ind: "fr" },
    { name: "Anglais", ind: "en" },
    { name: "Espagnol", ind: "es" },
    { name: "Allemand", ind: "de" },
    { name: "Chinese", ind: "zh" },
    { name: "Portuguese", ind: "pt" },
    { name: "Japanese", ind: "ja" },
    { name: "Russian", ind: "ru" },
    { name: "Italian", ind: "it" },
    { name: "Korean", ind: "ko" },
    { label: "Espagnol", ind: "sp" }
  ];
  const optionGroup2 = [
    { label: "Français", value: "fr" },
    { label: "Anglais", value: "en" },
    { label: "Espagnol", value: "sp" },
    { label: "German", value: "de" },
    { label: "Chinese", value: "zh" },
    { label: "Portuguese", value: "pt" },
    { label: "Japanese", value: "ja" },
    { label: "Russian", value: "ru" },
    { label: "Italian", value: "it" },
    { label: "Korean", value: "ko" }
  ];

  // const languages = {
  //   fr: {
  //     label: "French",
  //     flag: france,
  //   },
  //   es: {
  //     label: "Spanish",
  //     flag: spain,
  //   },
  //   de: {
  //     label: "German",
  //     flag: germany,
  //   },
  //   ru: {
  //     label: "Russian",
  //     flag: russia,
  //   },
  //   it: {
  //     label: "Italian",
  //     flag: italy,
  //   },
  //   en: {
  //     label: "English",
  //     flag: usFlag,
  //   },
  //   zh: {
  //     label: "Chinese",
  //     flag: china,
  //   },
  //   pt: {
  //     label: "Portuguese",
  //     flag: portugal,
  //   },
  //   ja: {
  //     label: "Japanese",
  //     flag: japan,
  //   },
  //   ko: {
  //     label: "Korean",
  //     flag: south_korea,
  //   },
  //   sp: {
  //     label: "Spanish",
  //     flag: spain,
  //   },
  // };

  const languages = [
    {
      label: "Anglais",
      code: "en",
      flag: usFlag
    },
    {
      label: "Espagnol",
      code: "sp",
      flag: spain
    },
    {
      label: "Français",
      code: "fr",
      flag: french
    },
    {
      label: "Chinese",
      code: "zh",
      flag: china
    },
    {
      label: "German",
      code: "de",
      flag: germany
    },
    {
      label: "Portuguese",
      code: "pt",
      flag: portugal
    },
    {
      label: "Japanese",
      code: "ja",
      flag: japan
    },
    {
      label: "Russian",
      code: "ru",
      flag: russia
    },
    {
      label: "Italian",
      code: "it",
      flag: italy
    },
    {
      label: "Korean",
      code: "ko",
      flag: south_korea
    }
  ];
  const sendLanguageFlag = (lang) => {
    const [languageData] = languageStore.filter((val) => val.ind === lang);
    if (languageData) {
      const resultLanguage = languages[lang];
      return resultLanguage ? resultLanguage.flag : "";
    } else {
      return "";
    }
  };
  const animatedComponents = makeAnimated();

  // const handleMulti3 = (val) => {
  //   console.log("selectedMulti3 is", val);
  //   setselectedMulti3(val);
  // };

  //
  const tags = [
    {
      id: 19,
      parents: [1],
      text: "Catégories",
      value: "authorized_tags",
      status: false
    },
    ...StaticData.tagsList.map((tag, index) => {
      return {
        id: 19 + (index + 1),
        parents: [1, 19],
        text: props.t(tag.Name),
        value: tag.Name,
        status: false
      };
    })
  ];
  const [authorizations, setAuthorizations] = useState([
    ...StaticData.authorisations,
    ...tags
  ]);
  const onAuthorizationsChanged = (val) => {
    setAuthorizations(val);
  };

  const [notifications, setNotifications] = useState({
    high_trafic_alert: false, //(Alertes de Volume Élevé)
    email_transfer: false, //(Notifications de Transfert de Mail)
    urgent_response_alert: false, //(Alertes de Réponse Urgente)
    follow_up_reminder: false, //(Rappels de Suivi)
    tag_updates: false, //(Mises à Jour des Tags)
    performance_updates: false, //(Notfications de Performance)
    security_alerts: false, //(Alertes de Sécurité)
    important_customer_feedback: false, //(Feedback Client Important)
    system_updates: false, //(Mises à Jour du Système)
    technical_issue_alerts: false //(Alertes de Problèmes Techniques)
  });

  const [allCkecked, setAllChecked] = useState(false);

  // const all_checks = new Map();

  const user = JSON.parse(localStorage.getItem("authUser"));
  // console.log('user is', user);
  const dispatch = useDispatch();

  // const [employeesList, setEmployeesList] = useState([]);
  const [agentsList, setAgentsList] = useState([]);
  const [currentPlan, setCurrentPlan] = useState();
  const [currentPlanFeatures, setCurrentPlanFeatures] = useState();
  const [agentQty, setAgentQty] = useState(0);
  const [can_respond_to_thanks, setCanRespondToThanks] = useState(false);
  const [maxTeamMember, SetMaxTeamMember] = useState(0);
  const [activeAgents, setActiveAgents] = useState([]);

  const [loading, setLoading] = useState(false);
  const [updateUserPrefsLoading, setUpdateUserPrefsLoading] = useState({
    loading: false,
    title: "",
    message: ""
  });
  const [employeeEditActions, setEmployeesEditActions] = useState({});
  const [deleteAgentLoading, setDeleteAgentLoading] = useState({});
  const [updateAgentLoading, setUpdateAgentLoading] = useState(false);
  const [updateTimezoneLoading, setUpdateTimezoneLoading] = useState(false);

  const [isPasswordHidden, setIsPasswordHidden] = useState(true);
  const togglePasswordVisibility = () => {
    setIsPasswordHidden(!isPasswordHidden);
  };
  const onUpdateAgentLoading = (value) => {
    setUpdateAgentLoading(value);
  };
  const onUpdateTimezoneLoading = (value) => {
    setUpdateTimezoneLoading(value);
  };
  const onClickHandle = (value, idx) => {
    setCanRespondToThanks(value);
  };

  const [updateAgentsLoading, setUpdateAgentsLoading] = useState(false);
  const onLoadingChanged = (val) => {
    setUpdateAgentsLoading(val);
  };

  //
  const [btnprimary1, setBtnprimary1] = useState(false);

  // user
  const [userDetails, setUserDetails] = useState({
    first_name: "",
    last_name: "",
    gender: "",
    phone: "",
    address1: "",
    address2: "",
    country: "",
    state: "",
    city: "",
    zip: "",
    company_name: "",
    vat_number: ""
  });

  // phone number status
  const [phone_status, setPhone_status] = useState(false);
  // Dial Code
  const [phoneDialCode, setPhoneDialCode] = useState("");

  // Update Phone Modal
  const [updatePhoneModal, setupdatePhoneModal] = useState(false);
  const tog_phone_modal = () => {
    setupdatePhoneModal(!updatePhoneModal);
  };
  // Password Modal
  const [passwordModal, setPasswordModal] = useState(false);

  const tog_password_modal = () => {
    setPasswordModal(!passwordModal);
  };

  // Account verify Alert
  const [verificationCreationLoading, setVerificationCreationLoading] =
    useState(false);
  const [isVerificationCreated, setVerificationCreated] = useState(false);

  const [password, setPassword] = useState("");
  const onPasswordChange = (val) => {
    setPassword(val);
  };
  const [validation, setValidation] = useState({
    errors: null,
    touched: false
  });
  const [requestIsLoading, setRequestIsLoading] = useState(false);
  const onRequestIsLoading = (value) => {
    setRequestIsLoading(value);
  };

  const [modalInfo, setModalInfo] = useState({
    last_name: "",
    first_name: "",
    email: "",
    autorizations: []
  });

  const [agentModalInfo, setAgentModalInfo] = useState({
    agent_work_times: {},
    agent_name: "",
    // agent_alias: '',
    agent_language: [],
    agent_greeting: [],
    agent_polite_formula: []
  });

  const [ai_behavior, setAiBehavior] = useState({
    can_respond_to_thanks: false
  });

  const [selectedAgentLanguages, setSelectedAgentLanguages] = useState([]);
  const animated2Components = makeAnimated();
  const animated3Components = makeAnimated();

  const [hoverText, setHoverText] = useState([]);
  const [toneSelected, setToneSelected] = useState(null);
  const [selectedGreeting, setSelectedGreeting] = useState([]);
  const [selectedFormula, setSelectedFormula] = useState([]);

  const [agent, setAgent] = useState({
    agent_name: ""
    // alias: ''
  });

  const [nameInputTouched, setNameInputTouched] = useState(false);

  const [agentData, setagentData] = useState([]);
  const [maaiaPageRender, setMaaiaPageRender] = useState(false);

  const greetings = [
    {
      label: "Bonjour",
      code: "bj"
    },
    {
      label: "Bonsoir",
      code: "bs"
    },
    {
      label: "Comment vous allez ?",
      code: "cva"
    }
  ];

  const formulas = [
    {
      label: "Excellente journée",
      code: "exj"
    },
    {
      label: "Bonne journée",
      code: "bnj"
    },
    {
      label: "Excellente soirée",
      code: "exs"
    },
    {
      label: "Bonne soirée",
      code: "bns"
    }
  ];

  const [greetOptions, setGreetOptions] = useState(greetings);

  const [maaiaNames, setMaaiaNames] = useState([]);
  const [inputValue, setInputValue] = useState("");
  const [addCollaboratorError, setAddCollaboratorError] = useState(undefined);

  const toggleToast = () => {
    console.log("setToast before: " + toast);
    setToast(true);
    console.log("setToast after: " + toast);

    setTimeout(() => {
      setToast(false);
    }, 3000);
  };

  const togglePhoneToast = () => {
    console.log("setToast before: " + validation.errors);
    setValidation({ ...validation, errors: false });
    console.log("setToast after: " + validation.errors);

    setTimeout(() => {
      setValidation({ ...validation, errors: false });
    }, 3000);
  };

  const handleEmployeeAdded = async () => {
    setAddCollaboratorError(undefined);
    let autorizations = [];
    let contact_reasons = [];
    const tags_ids = tags.map((tag) => tag.id);
    authorizations.forEach((auth) => {
      if (auth.status) {
        if (tags_ids.includes(auth.id)) {
          if (auth.value !== "authorized_tags") {
            contact_reasons.push(auth.value);
          }
        } else {
          if (auth.parents.length === 0) {
            autorizations.push(auth.value);
            // setAddCollaboratorError("Aucune autorisation accordée");
            return;
          } else {
            autorizations.push(auth.value);
          }
        }
      }
    });
    console.log({ tags_ids, contact_reasons });

    modalInfo.autorizations = autorizations;
    onLoading(true);
    let theClientInfos;

    theClientInfos = await getClientData();
    if (!theClientInfos) {
      setAddCollaboratorError("Erreur inattendue");
      return;
    }

    console.log({ modalInfo: modalInfo });

    if (modalInfo.autorizations.length === 0) {
      onLoading(false);
      setAddCollaboratorError("Aucune autorisation accordée");
      return;
    }

    const employeeAccount = await createEmployeeAccount({
      last_name: modalInfo.last_name,
      first_name: modalInfo.first_name,
      email: modalInfo.email,
      autorizations: modalInfo.autorizations,
      contact_reasons: contact_reasons,
      notifications: notifications
    });
    console.log({ employeeAccount });
    if (employeeAccount.code && employeeAccount.code === 409) {
      onLoading(false);
      setAddCollaboratorError("Compte déjà existant");
      return;
    }
    if (employeeAccount.code && employeeAccount.code === 400) {
      onLoading(false);
      setAddCollaboratorError("Email incorrect");
      return;
    }

    const newItem = {
      id: employeeAccount.$id,
      last_name: modalInfo.last_name,
      first_name: modalInfo.first_name,
      email: modalInfo.email,
      autorizations: modalInfo.autorizations,
      contact_reasons: contact_reasons,
      notifications: JSON.stringify(notifications)
    };

    const updatedList = [...(client_data?.collaborators ?? []), newItem];
    console.log("List des employee stringify", JSON.stringify(updatedList));
    theClientInfos = await updateClientInfos({
      collaborators: updatedList.map((element) => element)
    });
    if (!theClientInfos) {
      onLoading(false);
      setAddCollaboratorError("Échec d'enregistrement du collaborateur");
      return;
    }

    console.log(updatedList);
    // setEmployeesList(updatedList);
    setModalInfo({});
    // const prefs = new Map().merge(userPrefs, updatedList);
    // userPrefs["employees"] = updatedList;
    // await updateUserPrefs(userPrefs);

    if (!employeeAccount) {
      return;
    }
    await createEmployeeLink(
      employeeAccount.$id,
      localStorage.getItem("companyId")
    );

    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: employeeAccount.$createdAt,
      author_id: user_id,
      company_id: client_data?.$id,
      employee_id: employeeAccount.$id
    };
    let logdata = {
      event: "employee_added",
      author_id: user_id,
      company_id: client_data?.$id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);

    onLoading(false);

    tog_list();
  };

  // const handleAgentAdded = async () => {
  //   /*****************************************/
  //   // console.log("PrintTimes", timesByDay);
  //   // const errors = {};

  //   // daysOfWeek.forEach(day => {
  //   //   if (timesByDay[day].checked) {
  //   //     if (!timesByDay[day].open || !timesByDay[day].close) {
  //   //       errors[day] = "Veuillez sélectionner les heures d'ouverture et de fermeture.";
  //   //     }
  //   //     if (timesByDay[day].open > timesByDay[day].close) {
  //   //       errors[day] = "L'heure d'ouverture doit être antérieure à l'heure de fermeture.";
  //   //     }
  //   //   }
  //   // });

  //   // if (Object.keys(errors).length > 0) {
  //   //   setFormErrors(errors);
  //   // } else {
  //   //   setFormErrors({});
  //   // modalInfo.agent_language = selectedOption;
  //   agentModalInfo.agent_work_times = timesByDay;
  //   agentModalInfo.agent_timezone = agentSelectedTimezone;
  //   const agent_id = Date.now().toString();
  //   const newItem = {
  //     id: agent_id,
  //     agent_work_times: agentModalInfo.agent_work_times,
  //     agent_name: agentModalInfo.agent_name,
  //     // agent_alias: agentModalInfo.agent_alias,
  //     agent_language: agentModalInfo.agent_language,
  //     agent_timezone: agentModalInfo.agent_timezone,
  //     active: false
  //   };

  //   const updatedList = [...agentsList, newItem];
  //   // setItemStates(Array(updatedList.length).fill({ spanVisible: false, buttonDisabled: false, element_loading: false }));
  //   console.log("updatedAgentsList is", updatedList);

  //   onLoadingChanged(true);

  //   const agent_function_created = await createAgentFunctionExecution(client_data.$id, agent_id);

  //   if (!agent_function_created) {
  //     onLoadingChanged(false);
  //     return;
  //   }

  //   const response = await updateCompanyInfos({
  //     agents: updatedList.map((element) => JSON.stringify(element))
  //   });

  //   if (response) {
  //     const agents = response.agents.map((element) => JSON.parse(element));
  //     setAgentsList(agents);
  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     let logData = {
  //       eventCreatedAt: response?.$createdAt,
  //       author_id: user_id,
  //       company_id: client_data.$id,
  //       agent_id: newItem.id
  //     };
  //     let logdata = {
  //       event: "agent_added",
  //       author_id: user_id,
  //       company_id: client_data.$id,
  //       log_data: JSON.stringify(logData)
  //     };
  //     createLog(logdata, mixPanelTrack);
  //     toggleToast();
  //     // clearAgentModalInfo();
  //     onLoadingChanged(false);
  //     togAddAgentModal();
  //   } else {
  //     // Gérer les erreurs ici si nécessaire
  //     console.error("Erreur lors de la mise à jour des informations de l'entreprise :");
  //   }

  //   // }
  // };

  // const handleModalAgentUpdate = async () => {
  //   // const index = agentsList.findIndex((agent) => agent.id === id);
  //   agentModalInfo.agent_work_times = timesByDay;
  //   agentModalInfo.agent_timezone = agentSelectedTimezone;
  //   agentModalInfo.agent_greeting = selectedGreeting;
  //   agentModalInfo.agent_polite_formula = selectedFormula;
  //   agentModalInfo.agent_tone_communication = toneSelected;
  //   const updatedAgentsList = [...agentsList];
  //   updatedAgentsList[0] = {
  //     ...updatedAgentsList[0],
  //     agent_work_times: agentModalInfo.agent_work_times,
  //     agent_name: maaiaNames,
  //     agent_language: agentModalInfo.agent_language,
  //     agent_timezone: agentModalInfo.agent_timezone,
  //     agent_greeting: agentModalInfo.agent_greeting,
  //     agent_polite_formula: agentModalInfo.agent_polite_formula,
  //     agent_tone_communication: agentModalInfo.agent_tone_communication
  //   };

  //   console.log("updatedAgentsList is", updatedAgentsList);

  //   onUpdateAgentLoading(true);

  //   updateCompanyInfos({
  //     agents: updatedAgentsList.map((element) => JSON.stringify(element))
  //   })
  //     .then((response) => {
  //       onUpdateAgentLoading(false);
  //       const agents = response.agents.map((element) => JSON.parse(element));
  //       setAgentsList(agents);
  //       // clearAgentModalInfo();

  //       // Créer le log
  //       var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //       let logData = {
  //         eventCreatedAt: response?.$createdAt,
  //         author_id: user_id,
  //         company_id: client_data.$id,
  //         agent_id: agent.$id
  //       };
  //       let logdata = {
  //         event: "agent_updated",
  //         author_id: user_id,
  //         company_id: client_data.$id,
  //         log_data: JSON.stringify(logData)
  //       };
  //       createLog(logdata, mixPanelTrack);

  //       // togUpdateAgentModal();
  //       onUpdateAgentLoading(false);

  //       setUpdateUserPrefsLoading({
  //         title: props.t("Succès"),
  //         message: props.t("Vos modifications ont été enregistrées avec succès"),
  //         loading: false,
  //         key: "succes"
  //       });
  //       toggleToast();
  //     })
  //     .catch((error) => {
  //       // Gérer les erreurs ici si nécessaire
  //       console.error("Erreur lors de la mise à jour des informations de l'entreprise :", error);
  //       onUpdateAgentLoading(false);
  //       // togUpdateAgentModal();
  //       setUpdateUserPrefsLoading({
  //         title: props.t("Echec"),
  //         message: props.t("Erreur inattendu, veuillez réessayer."),
  //         loading: false,
  //         key: "danger"
  //       });
  //       toggleToast();
  //     });
  // };

  // const updateAgentStatus = async (id, status) => {
  //   const index = agentsList.findIndex((agent) => agent.id === id);
  //   const updatedAgentsList = [...agentsList];
  //   updatedAgentsList[index] = {
  //     ...updatedAgentsList[index],
  //     active: status
  //   };

  //   console.log("updatedAgentsList is", updatedAgentsList);

  //   onUpdateAgentLoading(true);

  //   updateCompanyInfos({
  //     agents: updatedAgentsList.map((element) => JSON.stringify(element))
  //   })
  //     .then((response) => {
  //       onUpdateAgentLoading(false);
  //       const agents = response.agents.map((element) => JSON.parse(element));
  //       setAgentsList(agents);
  //       // clearAgentModalInfo();

  //       // Créer le log
  //       var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //       let logData = {
  //         eventCreatedAt: response?.$createdAt,
  //         author_id: user_id,
  //         company_id: client_data.$id,
  //         agent_id: id
  //       };
  //       let logdata = {
  //         event: "agent_updated",
  //         author_id: user_id,
  //         company_id: client_data.$id,
  //         log_data: JSON.stringify(logData)
  //       };
  //       createLog(logdata, mixPanelTrack);

  //       // togUpdateAgentModal();
  //     })
  //     .catch((error) => {
  //       // Gérer les erreurs ici si nécessaire
  //       console.error("Erreur lors de la mise à jour des informations de l'entreprise :", error);
  //     });
  // };

  // const deleteAgentActions = async (id) => {
  //   setDeleteAgentLoading((prevState) => ({
  //     ...prevState,
  //     [id]: true
  //   }));

  //   let applyed = true;
  //   // applyed = await deleteAgent(localStorage.getItem("companyId"), id);

  //   if (applyed) {
  //     const updatedAgentsList = agentsList.filter((agent) => agent.id !== id);
  //     const response = await updateCompanyInfos({
  //       agents: updatedAgentsList.map((element) => JSON.stringify(element))
  //     });
  //     const agents = response.agents.map((element) => JSON.parse(element));
  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     let logData = {
  //       eventCreatedAt: response?.$createdAt,
  //       author_id: user_id,
  //       company_id: client_data.$id,
  //       agent_name: agentsList.find((agent) => agent.id === id).agent_name
  //     };
  //     let logdata = {
  //       event: "agent_deleted",
  //       author_id: user_id,
  //       company_id: client_data.$id,
  //       log_data: JSON.stringify(logData)
  //     };
  //     createLog(logdata, mixPanelTrack);

  //     setAgentsList(agents);
  //   }
  //   setDeleteAgentLoading((prevState) => ({
  //     ...prevState,
  //     [id]: false
  //   }));
  // };

  const handleModalEmployeeUpdate = async () => {
    let autorizations = [];
    let contact_reasons = [];
    const tags_ids = tags.map((tag) => tag.id);
    authorizations.forEach((auth) => {
      if (auth.status) {
        if (tags_ids.includes(auth.id)) {
          if (auth.value !== "authorized_tags") {
            contact_reasons.push(auth.value);
          }
        } else {
          if (auth.parents.length === 0) {
            autorizations.push(auth.value);
            return;
          } else {
            autorizations.push(auth.value);
          }
        }
      }
    });
    console.log({ tags_ids, contact_reasons });

    onLoading(true);

    const theCompayInfos = await getClientData();
    if (!theCompayInfos) {
      onLoading(false);
      return;
    }

    const collaborators = theCompayInfos.collaborators;

    const updatedList = [...collaborators];
    const index = updatedList.findIndex(
      (employee) => employee.id === employeeToUpdate.id
    );
    updatedList[index] = {
      ...employeeToUpdate,
      autorizations: autorizations,
      contact_reasons: contact_reasons,
      notifications: JSON.stringify(notifications)
    };

    const response = await updateClientInfos({
      collaborators: updatedList.map((element) => element)
    });
    if (!response) {
      return;
    }

    console.log({ updatedList });
    // setEmployeesList(updatedList);
    // userPrefs["employees"] = updatedList;

    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      employee_id: employeeToUpdate.id
    };
    let logdata = {
      event: "employee_updated",
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);

    tog_updateEmployeeModal();
  };

  const decodeAuthozations = (autorizations, employee) => {
    console.log("autorizations is:", autorizations);
    clearAllCheckBoxes();

    // ...[employee.contact_reasons && employee.contact_reasons.length > 0 ? "authorized_tags" : ""]
    if (employee.contact_reasons && employee.contact_reasons.length > 0) {
      autorizations.push("authorized_tags");
    }
    const updatedAuthorizations = [...authorizations];
    autorizations.forEach((auth_database) => {
      if (auth_database === "Toutes les autorisations sont sélectionnées") {
        for (let i = 0; i < updatedAuthorizations.length; i++) {
          updatedAuthorizations[i] = {
            ...updatedAuthorizations[i],
            status: true
          };
        }
        return;
      } else {
        authorizations.forEach((auth, idx) => {
          if (auth.value === auth_database) {
            updatedAuthorizations[idx] = {
              ...updatedAuthorizations[idx],
              status: true
            };
          }
        });
      }
    });
    setAuthorizations(updatedAuthorizations);
  };

  const clearAllCheckBoxes = () => {
    const updatedAuthorizations = [...authorizations];
    for (let i = 0; i < updatedAuthorizations.length; i++) {
      updatedAuthorizations[i] = { ...updatedAuthorizations[i], status: false };
    }
    setAuthorizations(updatedAuthorizations);
  };

  const clearAgentModalInfo = () => {
    setAgentModalInfo({
      agent_work_times: {},
      agent_name: "",
      // agent_alias: '',
      agent_language: []
    });
    setTimesByDay({
      week: {
        open: 0,
        close: 24
      },
      week_end: {
        open: 0,
        close: 24
      }
    });
  };

  const deleteUserRole = async (employee_id, employee_email) => {
    const theCompayInfo = await getClientData();
    console.log("employee datas ", theCompayInfo.collaborators);

    const collaborators = theCompayInfo.collaborators;

    if (!theCompayInfo) {
      console.log("no employee datas");
      setEmployeesEditActions((prevState) => ({
        ...prevState,
        [employee_id]: { state: true, loading: false }
      }));
      return;
    }

    const updatedList = collaborators.filter((item) => item.id !== employee_id);

    const response = await updateClientInfos({
      collaborators: updatedList.map((element) => element)
    });

    if (!response) {
      setEmployeesEditActions((prevState) => ({
        ...prevState,
        [employee_id]: { state: true, loading: false }
      }));
      return;
    }

    const employeeLink = await getEmployeeLinks(employee_id);
    if (employeeLink && employeeLink.length > 0) {
      const theLink = employeeLink.filter(
        (item) =>
          item.employee_id === employee_id &&
          item.company_id === localStorage.getItem("companyId")
      );
      if (theLink) {
        console.log("theLink is", theLink);
        const deletedEmployee = await deleteEmployeeLink(theLink[0].$id);
        if (deletedEmployee) {
          console.log(updatedList);
          //   setEmployeesList(updatedList);
        }
      } else {
        console.log("no theLink found", theLink);
      }
    }

    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      employee_email: employee_email
    };
    let logdata = {
      event: "employee_deleted",
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);

    setEmployeesEditActions((prevState) => ({
      ...prevState,
      [user_id]: { state: true, loading: false }
    }));
  };

  // const updateUserRole = async (user_id) => {
  //   onLoading(true);
  //   const employees = await getCompanyEmployeesData();
  //   if (!employees || employees.length === 0) {
  //     return;
  //   }

  //   const newItem = {
  //     id: user_id,
  //     last_name: modalInfo.last_name,
  //     first_name: modalInfo.first_name,
  //     email: modalInfo.email,
  //     autorizations: modalInfo.autorizations,
  //   };

  //   const updatedList = employeesList.map((item) => {
  //     if (item.id === user_id) {
  //       return newItem;
  //     }
  //     return item;
  //   });

  //   console.log(updatedList);
  //   setEmployeesList(updatedList);

  //   const employeeList = await updateCompanyEmployeesData(company_employees_data.$id, {
  //     employees: updatedList.map((element) => JSON.stringify(element)),
  //   });
  //   if (!employeeList) {
  //     return;
  //   }

  //   const employeeLink = await getEmployeeLinks(user_id);
  //   if (employeeLink && employeeLink.length > 0) {
  //     const theLink = employeeLink.filter((item) => item.employee_id === user_id && item.company_id === employees[0].company_id);
  //     if (theLink) await deleteEmployeeLink(theLink.$id);
  //   }
  // };

  const { state } = useLocation();
  // console.log({ state });
  const tabNames = {
    general: "1",
    email: "2",
    profile: "4",
    agents: "5",
    users: "6",
    billing: "7",
    notifications: "8",
    logs: "9",
    facebook: "10",
    whatsapp: "11"
  };
  const toggleVerticalIcon = (tab) => {
    if (verticalActiveTabWithIcon !== tab) {
      setverticalActiveTabWithIcon(tab);
    }
  };

  const [verticalActiveTabWithIcon, setverticalActiveTabWithIcon] =
    useState("5");

  // New Logic - Accordion
  const handleParentCheckboxChange = (
    updatedAuthorizations,
    parentId,
    value,
    id
  ) => {
    // Find Children and apply the parent new value
    console.log({ parentchecked: value });
    // let updatedAuthorizations = [...authorizations];
    updatedAuthorizations.forEach((authorization, idx) => {
      if (authorization.parents.includes(parentId)) {
        updatedAuthorizations[idx] = { ...authorization, status: value };
      }
    });

    if (id) {
      // if value false then uncheck first degree parent
      if (!value) {
        updatedAuthorizations[0] = {
          ...updatedAuthorizations[0],
          status: false
        };
      } else {
        let allChildrenChecked = true;
        // verify if all children besides the one of the parent changed are checked
        updatedAuthorizations.forEach((auth) => {
          if (
            !auth.parents.includes(id) &&
            auth.id !== 1 &&
            auth.status === false
          ) {
            allChildrenChecked = false;
          }
        });
        // if all children are checked then check the second degree parent
        if (allChildrenChecked) {
          updatedAuthorizations[0] = {
            ...updatedAuthorizations[0],
            status: true
          };
        }
      }
    }

    console.log("updatedAuthorizations is", updatedAuthorizations);
    setAuthorizations(updatedAuthorizations);
  };
  const handleChildCheckboxChange = (
    updatedAuthorizations,
    id,
    parentId,
    value
  ) => {
    // let updatedAuthorizations = [...authorizations];
    const index = updatedAuthorizations.findIndex(
      (auth) => auth.id === parentId
    );
    // if value true then check first degree parent
    if (value) {
      updatedAuthorizations[index] = {
        ...updatedAuthorizations[index],
        status: true
      };

      let allChildrenChecked = true;
      // verify if all children besides the one changed and the first auth are ckecked
      updatedAuthorizations.forEach((auth) => {
        if (auth.id !== id && auth.id !== 1 && auth.status === false) {
          allChildrenChecked = false;
        }
      });
      // if all children are checked then check the second degree parent
      if (allChildrenChecked) {
        updatedAuthorizations[0] = {
          ...updatedAuthorizations[0],
          status: true
        };
      }
    } else {
      // uncheck second degree parent
      updatedAuthorizations[0] = { ...updatedAuthorizations[0], status: false };

      let allChildrenUnChecked = true;
      // verify if all children besides the one changed are unchecked
      updatedAuthorizations.forEach((auth) => {
        if (
          auth.parents.includes(parentId) &&
          auth.id !== id &&
          auth.status === true
        ) {
          allChildrenUnChecked = false;
        }
      });

      // if all children are unchecked then uncheck the first degree parent
      if (allChildrenUnChecked) {
        updatedAuthorizations[index] = {
          ...updatedAuthorizations[index],
          status: false
        };
      }
    }
    setAuthorizations(updatedAuthorizations);
  };

  const handleNotifCheckChange = (current_key, value) => {
    const updatedNotifs = { ...notifications };
    updatedNotifs[current_key] = value;
    // Vérifier si toutes les valeurs sont true
    const isAllChecked = Object.values(updatedNotifs).every(
      (val) => val === true
    );
    // Attribuer la valeur à allchecked
    setAllChecked(isAllChecked);
  };

  const handleNotifAllCheck = (val) => {
    const updatedNotifs = { ...notifications };
    for (const key in updatedNotifs) {
      if (updatedNotifs.hasOwnProperty(key)) {
        updatedNotifs[key] = val;
      }
    }
    setNotifications(updatedNotifs);
  };

  function tog_list() {
    if (modal_list) {
      clearAllCheckBoxes();
      handleNotifAllCheck(false);
    }
    setmodal_list(!modal_list);
  }

  function togAddAgentModal() {
    setAddAgentModal(!addAgentModal);
  }
  function togUpdateAgentModal() {
    setUpdateAgentModal(!updateAgentModal);
    // clearAgentModalInfo();
  }
  function tog_updateEmployeeModal() {
    if (updateEmployeeModal) {
      clearAllCheckBoxes();
      handleNotifAllCheck();
    }
    setUpdateEmployeeModal(!updateEmployeeModal);
  }

  const onEmployeeToUpdateChanged = (emp) => {
    setEmployeeToUpdate(emp);
    setNotifications(JSON.parse(emp.notifications));
    setAllChecked(
      Object.values(JSON.parse(emp.notifications)).every((val) => val === true)
    );
  };

  // const handleDropdownItemClick = (option) => {
  //   console.log("handleDropdownItemClick", option);
  //   setSelectedOption(option);
  //   setbtnmenu1(!btnmenu1);
  // };

  function setUtc(timezone) {
    const timeutc = moment.tz(timezone).utcOffset() / 60;
    const optionText = `${timezone} (UTC${timeutc >= 0 ? "+" : ""}${timeutc})`;
    return optionText;
  }
  const onLoading = (val) => {
    setLoading(val);
  };

  async function updateUserPhone(tel, password) {
    const client = new Client();

    const account = new Account(client);

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = account.updatePhone(tel, password);

    return promise.then(
      async function (response) {
        onRequestIsLoading(false);
        setValidation({ ...validation, errors: null });
        onPasswordChange("");
        const new_prefs = userPrefs;
        new_prefs["phone"] = tel !== "" ? tel : new_prefs["phone"];
        console.log("new_tel is", new_prefs["phone"]);
        const res = await updateUserPrefs(new_prefs);
        if (!res) {
          return;
        }
        // Créer le log
        var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
        let logData = {
          eventCreatedAt: res.$createdAt,
          author_id: user_id,
          company_id: localStorage.getItem("companyId")
        };
        let logdata = {
          event: "profil_details_updated",
          author_id: user_id,
          company_id: localStorage.getItem("companyId"),
          log_data: JSON.stringify(logData)
        };
        createLog(logdata, mixPanelTrack);
        console.log("new userPhone is ", response); // Success
        tog_phone_modal();
      },
      function (error) {
        onRequestIsLoading(false);
        onPasswordChange("");
        if (error.type === "user_invalid_credentials") {
          setValidation({ ...validation, errors: "Mot de passe incorrect" });
        } else {
          setValidation({ ...validation, errors: error.message });
        }

        console.log("error on userPhone update ", error); // Failure
      }
    );
  }
  async function updateUserPrefs(userPrefs) {
    const client = new Client();

    const account = new Account(client);

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = account.updatePrefs(userPrefs);

    return promise.then(
      function (response) {
        console.log("new userPrefs is ", response); // Success
        setUserPrefs(userPrefs);
        setUserDetails(userPrefs);
        setUpdateUserPrefsLoading({
          title: props.t("Success"),
          message: props.t("Enregistrement réussi"),
          key: "success",
          loading: false
        });
        toggleToast();
        return response;
      },
      function (error) {
        setUpdateUserPrefsLoading({
          title: props.t("Echec"),
          message: error.message,
          key: "danger",
          loading: false
        });
        toggleToast();
        console.log("error on userPrefs update ", error); // Failure
        return null;
      }
    );
  }
  async function getUserPrefs() {
    // setRequest(true);

    const client = new Client();
    const account = new Account(client);

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = account.getPrefs();
    return promise.then(
      async function (response) {
        // console.log("userInfos is", response);
        setUserPrefs(response);
        setSelectedTimezone(
          response.time_zone ?? setUtc(moment.tz.guess(true))
        );
        setUserDetails({ ...response, gender: response.gender });
        // setEmployeesData(response["employees"] || []);
      },
      function (error) {
        console.log(error);
      }
    );
  }

  async function getUserAccount() {
    // setRequest(true);

    const client = new Client();
    const account = new Account(client);

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = account.get();
    return promise.then(
      async function (response) {
        // console.log("userAccount is", response);
        // setRequest(false);
        //     if(client_data.mail_config){
        //    }
        //fetchMailBoxes(data);
        const user = response;
        setUserInfos(user);

        if (user.prefs && user.prefs["owner"]) {
          const employeeLink = await getEmployeeLink();
          if (!employeeLink || employeeLink.length === 0) {
            await createEmployeeLink(user.$id, user.$id);
          }
          // const employees = await getCompanyEmployeesData();
          // if (employees.length === 0) {
          //   await createCompanyEmployeesData(
          //     JSON.stringify({
          //       id: user.$id,
          //       last_name: user.name,
          //       first_name: "",
          //       email: user.email
          //     }),
          //     [],
          //     user.$id
          //   );
          // }
        }
      },
      function (error) {
        console.log("Error getting user Account ", error);
        console.log(error); // Failure
        // setRequest(false);
      }
    );
  }

  function generateRandomPassword(minLength = 8, maxLength = 14) {
    // Tableau de caractères à utiliser pour générer le mot de passe
    const chars = [
      // Lettres minuscules
      "abcdefghijklmnopqrstuvwxyz",
      // Lettres majuscules
      "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
      // Chiffres
      "0123456789",
      // Caractères spéciaux
      '@#$%^&*()_+-={}[]:";'
    ];

    // Longueur du mot de passe
    const length =
      Math.floor(Math.random() * (maxLength - minLength + 1)) + minLength;

    // Mot de passe généré
    let password = "";

    // Génération des caractères du mot de passe
    for (let i = 0; i < length; i++) {
      // Choix d'un caractère aléatoire parmi les caractères disponibles
      const index = Math.floor(Math.random() * chars.length);
      password += chars[index][Math.floor(Math.random() * chars[index].length)];
    }

    return password;
  }

  // const updateEmployeePrefs = async (pref) => {
  //   onLoading(true);

  //   const baseUrl = "https://smartas-srv.semecloud.tech/v1/account/prefs";
  //   try {
  //     const response = await axios.patch(
  //       baseUrl,
  //       {
  //         prefs: pref,
  //       },

  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-Appwrite-Project": process.env.REACT_APP_PROJECTID,
  //           "X-Appwrite-Response-Format": "1.0.0",
  //           "X-Appwrite-Key": "1.0.0",
  //         },
  //       }
  //     );
  //     onLoading(false);
  //     return response;
  //   } catch (error) {
  //     onLoading(false);
  //     console.error("Error", error);
  //     throw error;
  //   }
  // };

  async function createEmployeeAccount(employee) {
    console.log({ employee });
    try {
      const str_response = await createEmployeeFunction(employee);
      console.log("userAccount is", str_response);
      // const response = JSON.parse(str_response.responseBody);
      return str_response;
    } catch (error) {
      console.error({ createEmployeeAccountError: error }); // Gestion de l'erreur
      return null;
    }
  }

  async function getEmployeeLink() {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "employee_link", [
      Query.equal("employee_id", localStorage.getItem("companyId"))
    ]);

    return promise.then(
      async function (response) {
        // console.log("Employee link is ", response.documents); // Failure
        return response.documents;
      },
      function (error) {
        onLoading(false);
        console.log("Error creating Employee link", error); // Failure
        return null;
      }
    );
  }

  async function getEmployeeLinks(the_id) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.listDocuments("default", "employee_link", [
      Query.equal("employee_id", the_id)
    ]);

    return promise.then(
      async function (response) {
        console.log("specific Employee links is ", response.documents); // Failure
        return response.documents;
      },
      function (error) {
        onLoading(false);
        console.log("Error getting specific Employee links", error); // Failure
        return null;
      }
    );
  }

  async function createEmployeeLink(employee_account_id, company_id) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.createDocument(
      "default",
      "employee_link",
      ID.unique(),
      { employee_id: employee_account_id, company_id: company_id }
    );

    return promise.then(
      async function (response) {
        console.log("Employee link created ", response); // Success
        return response;
      },
      function (error) {
        onLoading(false);
        console.log("Error creating Employee link", error); // Failure
        return null;
      }
    );
  }

  async function deleteEmployeeLink(employee_link_id) {
    const client = new Client();
    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.deleteDocument(
      "default",
      "employee_link",
      employee_link_id
    );

    return promise.then(
      async function (response) {
        console.log("Employee link deleted ", response); // Failure
        return response;
      },
      function (error) {
        onLoading(false);
        console.log("Error deleting Employee link", error); // Failure
        return null;
      }
    );
  }

  // async function getCompanyEmployeesData() {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.listDocuments("default", "employee", [Query.equal("company_id", localStorage.getItem("companyId"))]);

  //   return promise.then(
  //     async function (response) {
  //       console.log({ response });
  //       const employeeData = response.documents;
  //       if (employeeData.length > 0) {
  //         setCompanyEmployeesData(employeeData[0]);
  //         const employeesList = employeeData[0].employees;
  //         console.log("EmployeesList is", employeesList);
  //         const employees = employeesList.map((element) => JSON.parse(element));
  //         setEmployeesList(employees);
  //         if (employeeData[0].owner) {
  //           // console.log('owner is', employeeData[0].owner);
  //           setOwnerInfos(JSON.parse(employeeData[0].owner));
  //         }
  //       }
  //       return employeeData;
  //     },
  //     function (error) {
  //       console.log("Error listing company employees ", error);
  //       console.log(error); // Failure
  //       return null;
  //     }
  //   );
  // }

  const namesToArray = (names) => {
    if (Array.isArray(names)) {
      return names;
    }
    return [{ label: names, value: names }];
  };

  const getClientData = async function () {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.getDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId")
    );

    return promise.then(
      async function (response) {
        applyClientInfosData(response);
        // if (agents.length > 0) {
        //   setTimesByDay(agents[0].agent_work_times);
        // }
        // handleSwitchAiBehavior(response.move_treated_emails, "move_treated_emails");
        // handleSwitchAiBehavior(response.reply_to_thank_messages, "reply_to_thank_messages");

        return response;
      },
      async function (error) {
        setLoading(false);
        console.log("Error on getClientData", error, error.code);
        return null;
      }
    );
  };

  // async function createCompanyInfos(data) {
  //   onLoadingChanged(true);

  //   const client = new Client();

  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.createDocument("default", "client_infos", localStorage.getItem("companyId"), data);

  //   promise.then(
  //     async function (response) {
  //       console.log(response);
  //       setCompanyInfos(response);
  //       // console.log('company info is ', response);
  //       const agentsList = response.agents;
  //       const agents = agentsList.map((element) => JSON.parse(element));
  //       // console.log('agents is', agents);
  //       setAgentsList(agents);
  //     },
  //     function (error) {
  //       // onLoadingChanged(false);

  //       console.log("createCompanyInfos", error); // Failure
  //     }
  //   );
  // }

  function applyClientInfosData(response) {
    setCompanyInfos(response);

    // setEmployeesList(response.collaborators);
    const agentsList = response.agents;
    console.log({ response });

    const agents = agentsList.map((element) => JSON.parse(element));
    console.log("agents is", agents);
    setAgentsList(agents);

    console.log({ first_agent: agents[0] });
    const first_agent = agents[0];
    setagentData(agents);
    if (first_agent) {
      setAgent(first_agent);

      const names = namesToArray(first_agent.agent_name);
      setMaaiaNames(names);

      // setTimesByDay(first_agent.agent_work_times); à redefinir dans la base de données
      // changeLanguageAction(first_agent.agent_language[0].code, first_agent.agent_language[0].name);
      setAgentTimezone(first_agent.agent_timezone);

      // setAgentModalInfo(first_agent);
      // setTimesByDay(first_agent.agent_work_times);
      // setToneSelected(first_agent.agent_tone_communication);
      // setSelectedGreeting(first_agent.agent_greeting ?? []);
      // setSelectedFormula(first_agent.agent_polite_formula ?? []);
    }
  }

  // async function createCompanyEmployeesData(owner, employees, company_id) {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.createDocument("default", "employee", ID.unique(), {
  //     owner: owner,
  //     employees: employees.map((element) => JSON.stringify(element)),
  //     company_id: company_id
  //   });

  //   return promise.then(
  //     async function (response) {
  //       console.log("Employees list created ", response); // Failure
  //       return response;
  //     },
  //     function (error) {
  //       onLoading(false);
  //       console.log("Error creating Employees list", error); // Failure
  //       return null;
  //     }
  //   );
  // }

  // async function updateCompanyEmployeesData(id, data) {
  //   const client = new Client();
  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.updateDocument("default", "employee", id, data);

  //   return promise.then(
  //     async function (response) {
  //       onLoading(false);
  //       console.log("Employees list created ", response); // Failure
  //       return response;
  //     },
  //     function (error) {
  //       onLoading(false);
  //       console.log("Error updating Employees list", error); // Failure
  //       return null;
  //     }
  //   );
  // }

  async function updateClientInfos(data) {
    const client = new Client();

    const databases = new Databases(client, "default");

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = databases.updateDocument(
      "default",
      "client_infos",
      localStorage.getItem("companyId"),
      JSON.stringify(data)
    );

    return promise.then(
      async function (response) {
        console.log("updateCompanyInfos success", response); // Success
        applyClientInfosData(response);
        return response;
      },
      function (error) {
        console.log("updateCompanyInfos error", error); // Failure
        return null;
      }
    );
  }

  const saveUserPrefsActions = async () => {
    const new_prefs = userPrefs;
    setUpdateUserPrefsLoading({ ...updateUserPrefsLoading, loading: true });
    new_prefs["first_name"] =
      userDetails.first_name !== ""
        ? userDetails.first_name
        : new_prefs["first_name"];
    new_prefs["last_name"] =
      userDetails.last_name !== ""
        ? userDetails.last_name
        : new_prefs["last_name"];
    new_prefs["gender"] =
      userDetails.gender !== "" ? userDetails.gender : new_prefs["gender"];
    new_prefs["address1"] =
      userDetails.address1 !== ""
        ? userDetails.address1
        : new_prefs["address1"];
    new_prefs["address2"] =
      userDetails.address2 !== ""
        ? userDetails.address2
        : new_prefs["address2"];
    new_prefs["country"] =
      userDetails.country !== "" ? userDetails.country : new_prefs["country"];
    new_prefs["state"] =
      userDetails.state !== "" ? userDetails.state : new_prefs["state"];
    new_prefs["city"] =
      userDetails.city !== "" ? userDetails.city : new_prefs["city"];
    new_prefs["zip"] =
      userDetails.zip !== "" ? userDetails.zip : new_prefs["zip"];
    new_prefs["company_name"] =
      userDetails.company_name !== ""
        ? userDetails.company_name
        : new_prefs["company_name"];
    new_prefs["vat_number"] =
      userDetails.vat_number !== ""
        ? userDetails.vat_number
        : new_prefs["vat_number"];
    console.log("new_prefs is", new_prefs);
    const response = await updateUserPrefs(new_prefs);
    if (!response) {
      return;
    }
    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    var company_id = localStorage.getItem("companyId");

    const updates = {
      first_name:
        userDetails.first_name !== ""
          ? userDetails.first_name
          : new_prefs["first_name"],
      last_name:
        userDetails.last_name !== ""
          ? userDetails.last_name
          : new_prefs["last_name"],
      organization:
        userDetails.company_name !== ""
          ? userDetails.company_name
          : new_prefs["company_name"]
    };
    klaviyoUpdateProfile(company_id, updates);

    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id
    };
    let logdata = {
      event: "profil_details_updated",
      author_id: user_id,
      company_id,
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
  };

  const handleTimeZoneUpdate = async () => {
    onUpdateTimezoneLoading(true);
    const new_prefs = userPrefs;
    new_prefs["time_zone"] = selectedTimezone;
    console.log("new_prefs is", new_prefs);
    const response = await updateUserPrefs(new_prefs);
    if (!response) {
      return;
    }
    onUpdateTimezoneLoading(false);
    // Créer le log
    var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
    let logData = {
      eventCreatedAt: response?.$createdAt,
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      new_time_zone: selectedTimezone
    };
    let logdata = {
      event: "timezone_updated",
      author_id: user_id,
      company_id: localStorage.getItem("companyId"),
      log_data: JSON.stringify(logData)
    };
    createLog(logdata, mixPanelTrack);
  };

  // const formatDate = (str) => {
  //   //  return "";
  //   return new Date(str).toLocaleDateString(props.i18n.language + "-" + props.i18n.language.toUpperCase(), {
  //     day: "numeric",
  //     month: "short",
  //     year: "numeric",
  //     hour: "numeric",
  //     minute: "numeric"
  //   });
  // };

  const differenceInMilSec = (user) => {
    return Math.abs(new Date(user.passwordUpdate) - new Date(user.$createdAt));
  };

  const createAccountVerification = () => {
    setVerificationCreationLoading(true);
    const client = new Client()
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const account = new Account(client);

    const promise = account.createVerification(
      "https://app.synibox.io/account-verify"
    );

    promise.then(
      function (response) {
        console.log(response);
        setVerificationCreated(true);
        setVerificationCreationLoading(false);
      },
      function (error) {
        console.log(error);
        setVerificationCreationLoading(false);
      }
    );
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const tab = queryParams.get("tab");
  // console.log({ queryParams });
  // console.log("queryParams.URLSearchParams", queryParams.get("tab"));

  useEffect(() => {
    setMaaiaPageRender(true);
  }, []);

  useEffect(() => {
    if (state && state.tab) {
      toggleVerticalIcon(tabNames[state.tab]);
    }
    if (state && state.modal === "password") {
      tog_password_modal();
    }
    if (tab) {
      toggleVerticalIcon(tabNames[tab]);
    }
  }, [state]);

  useEffect(() => {
    // getCompanyEmployeesData();
    console.log({ autorisationData: authorizations });
    getClientData();
    setSelectedTimezone(setUtc(moment.tz.guess(true)));
    setAgentTimezone(setUtc(moment.tz.guess(true)));
    getUserPrefs();
    getUserAccount();
    const selectLang = localStorage.getItem("I18N_LANGUAGE") ?? "en";
    setselectLang(selectLang);
    //  handleListPlan();

    // // Fonction pour mettre à jour la valeur lorsque l'événement est déclenché
    // const handleValeurMiseAJour = (event) => {
    //   setselectLang(event.detail ?? "fr");
    // };
    // // Écouter l'événement personnalisé
    // window.addEventListener("valeurMiseAJour", handleValeurMiseAJour);

    // // Nettoyer l'écouteur d'événement lors du démontage du composant
    // return () => {
    //   window.removeEventListener("valeurMiseAJour", handleValeurMiseAJour);
    // };
  }, []);

  const { isUserPlanActive, number_of_languages } = useSelector((state) => ({
    isUserPlanActive: state.subscription.isUserPlanActive,
    number_of_languages: state.subscription.numberOfLanguages
  }));

  // useEffect(() => {
  //   if (isUserPlanActive) {
  //     setNumberOfLanguages(number_of_languages);
  //   } else {
  //     setNumberOfLanguages(0);
  //   }
  // }, [isUserPlanActive, number_of_languages]);

  const [isAtive, setIsActive] = useState(false);

  // const agentStatusChangeActions = async (index, old_val) => {
  //   setDeleteAgentLoading((prevState) => ({
  //     ...prevState,
  //     [agentsList[index].id]: true
  //   }));

  //   let applyed = true;
  //   // if (old_val === false) {
  //   //   applyed = await startAgent(agentsList[index].id);
  //   // } else {
  //   //   applyed = await stopAgent(agentsList[index].id);
  //   // }
  //   if (applyed) {
  //     const updatedAgentList = [...agentsList];
  //     updatedAgentList[index] = {
  //       ...updatedAgentList[index],
  //       active: !old_val
  //     };

  //     const response = await updateClientInfos({
  //       agents: updatedAgentList.map((element) => JSON.stringify(element))
  //     });
  //     if (!response) {
  //       setDeleteAgentLoading((prevState) => ({
  //         ...prevState,
  //         [agentsList[index].id]: false
  //       }));
  //       return;
  //     }

  //     if (old_val === false) {
  //       console.log({ "active agents now 1": [...activeAgents, agentsList[index].id] });
  //       setActiveAgents([...activeAgents, agentsList[index].id]);
  //     } else {
  //       console.log({ "active agents now 2": activeAgents.filter((agent_id) => agent_id !== agentsList[index].id) });
  //       setActiveAgents(activeAgents.filter((agent_id) => agent_id !== agentsList[index].id));
  //     }

  //     // Créer le log
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;
  //     var company_id = localStorage.getItem("companyId");

  //     const updates = {
  //       properties: {
  //         ai_active: old_val
  //       }
  //     };
  //     klaviyoUpdateProfile(company_id, updates);

  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id: company_id,
  //       agent_id: agentsList[index].id
  //     };
  //     let logdata = {
  //       event: old_val ? "agent_disabled" : "agent_enabled",
  //       author_id: user_id,
  //       company_id: company_id,
  //       log_data: JSON.stringify(logData)
  //     };
  //     createLog(logdata, mixPanelTrack);

  //     setAgentsList(updatedAgentList);
  //     setIsActive((prev) => {
  //       // dispatch(isActivatedAgentStatus(!prev));
  //       return !prev;
  //     });
  //   }
  //   setDeleteAgentLoading((prevState) => ({
  //     ...prevState,
  //     [agentsList[index].id]: false
  //   }));
  // };

  const svgs = {
    plus_icon: (
      <svg
        width="14"
        height="14"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.01667 13.7836C6.62474 13.7836 6.32189 13.6767 6.10811 13.4629C5.89433 13.2313 5.78744 12.9195 5.78744 12.5276V8.14517H1.48517C1.11106 8.14517 0.817111 8.04719 0.603333 7.85123C0.389556 7.63745 0.282667 7.34351 0.282667 6.96939C0.282667 6.59528 0.389556 6.31025 0.603333 6.11428C0.817111 5.9005 1.11106 5.79362 1.48517 5.79362H5.78744V1.54478C5.78744 1.15286 5.89433 0.850005 6.10811 0.636227C6.32189 0.422449 6.63365 0.315561 7.04339 0.315561C7.43532 0.315561 7.72926 0.422449 7.92522 0.636227C8.139 0.850005 8.24589 1.15286 8.24589 1.54478V5.79362H12.5482C12.9401 5.79362 13.234 5.9005 13.43 6.11428C13.6438 6.31025 13.7507 6.59528 13.7507 6.96939C13.7507 7.34351 13.6438 7.63745 13.43 7.85123C13.234 8.04719 12.9401 8.14517 12.5482 8.14517H8.24589V12.5276C8.24589 12.9195 8.139 13.2313 7.92522 13.4629C7.72926 13.6767 7.42641 13.7836 7.01667 13.7836Z"
          fill="currentColor"
        />
      </svg>
    ),
    edit_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          style={{ fillRule: "evenodd", clipRule: "evenodd" }}
          d="M0 15.6448V18.9334C0 19.2363 0.237992 19.4743 0.54089 19.4743H3.8295C3.97013 19.4743 4.11077 19.4202 4.20813 19.312L16.0212 7.50978L11.9645 3.4531L0.162267 15.2553C0.054089 15.3635 0 15.4933 0 15.6448ZM19.1535 4.37308C19.5754 3.95119 19.5754 3.26967 19.1535 2.84777L16.6221 0.316405C16.42 0.113839 16.1456 0 15.8594 0C15.5733 0 15.2989 0.113839 15.0968 0.316405L13.1171 2.29606L17.1738 6.35274L19.1535 4.37308Z"
          fill="#ccc"
        />
      </svg>
    ),
    delete_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="29"
        viewBox="0 0 28 29"
        fill="none"
      >
        <path
          d="M23.4933 10.5732L22.595 24.3845C22.5409 25.2252 22.1809 26.0133 21.5875 26.5897C20.9942 27.1661 20.2118 27.4878 19.3983 27.4899H8.595C7.78152 27.4878 6.99912 27.1661 6.40579 26.5897C5.81246 26.0133 5.45241 25.2252 5.39833 24.3845L4.5 10.5732H23.4933ZM17.6273 6.94824H10.366C10.0426 6.94811 9.72377 6.86843 9.43587 6.71576C9.14796 6.5631 8.89918 6.34181 8.70997 6.07011C8.52077 5.79841 8.39656 5.48406 8.34757 5.15294C8.29858 4.82181 8.3262 4.48336 8.42817 4.16545L8.819 2.95591C8.95372 2.53494 9.21316 2.16868 9.56044 1.90923C9.90771 1.64977 10.3251 1.51033 10.7533 1.51074H17.2377C17.6663 1.51028 18.0842 1.6498 18.4319 1.90947C18.7796 2.16913 19.0394 2.53573 19.1743 2.95712L19.5628 4.16424C19.6653 4.48213 19.6933 4.82068 19.6446 5.15199C19.5959 5.4833 19.4718 5.79787 19.2827 6.06977C19.0935 6.34167 18.8447 6.56312 18.5567 6.71586C18.2687 6.86859 17.9497 6.94824 17.6262 6.94824H17.6273ZM10.7545 3.32324C10.6934 3.32284 10.6337 3.3425 10.584 3.3794C10.5343 3.41631 10.4972 3.46856 10.478 3.52866L10.0883 4.7382C10.0737 4.78378 10.0697 4.83233 10.0768 4.87981C10.0839 4.92729 10.1018 4.97234 10.1291 5.01121C10.1563 5.05008 10.1922 5.08166 10.2336 5.10332C10.275 5.12498 10.3208 5.13609 10.3672 5.13574H17.6285C17.6749 5.13596 17.7207 5.1247 17.7621 5.1029C17.8035 5.08109 17.8392 5.04937 17.8664 5.01037C17.8936 4.97137 17.9113 4.92622 17.9182 4.87867C17.9252 4.83112 17.921 4.78255 17.9062 4.73699L17.5177 3.52987C17.4983 3.46954 17.461 3.4171 17.4111 3.38C17.3613 3.3429 17.3014 3.32304 17.24 3.32324H10.7545Z"
          fill="#F10944"
        />
        <path
          d="M11.6641 20.2396C11.432 20.2396 11.2094 20.1441 11.0453 19.9741C10.8813 19.8042 10.7891 19.5737 10.7891 19.3333V14.5C10.7891 14.2596 10.8813 14.0291 11.0453 13.8592C11.2094 13.6892 11.432 13.5938 11.6641 13.5938C11.8961 13.5938 12.1187 13.6892 12.2828 13.8592C12.4469 14.0291 12.5391 14.2596 12.5391 14.5V19.3333C12.5391 19.5737 12.4469 19.8042 12.2828 19.9741C12.1187 20.1441 11.8961 20.2396 11.6641 20.2396ZM16.3307 20.2396C16.0987 20.2396 15.8761 20.1441 15.712 19.9741C15.5479 19.8042 15.4557 19.5737 15.4557 19.3333V14.5C15.4557 14.2596 15.5479 14.0291 15.712 13.8592C15.8761 13.6892 16.0987 13.5938 16.3307 13.5938C16.5628 13.5938 16.7854 13.6892 16.9494 13.8592C17.1135 14.0291 17.2057 14.2596 17.2057 14.5V19.3333C17.2057 19.5737 17.1135 19.8042 16.9494 19.9741C16.7854 20.1441 16.5628 20.2396 16.3307 20.2396Z"
          fill="#EDEBEA"
        />
        <path
          d="M23.3333 5.13574H4.66667C4.12518 5.13574 3.60588 5.35853 3.22299 5.75509C2.8401 6.15165 2.625 6.6895 2.625 7.25033C2.625 7.81115 2.8401 8.349 3.22299 8.74556C3.60588 9.14212 4.12518 9.36491 4.66667 9.36491H23.3333C23.8748 9.36491 24.3941 9.14212 24.777 8.74556C25.1599 8.349 25.375 7.81115 25.375 7.25033C25.375 6.6895 25.1599 6.15165 24.777 5.75509C24.3941 5.35853 23.8748 5.13574 23.3333 5.13574Z"
          fill="#F10944"
        />
      </svg>
    ),
    close_icon: (
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.37 19.6142C19.0771 19.8983 18.778 20.038 18.4725 20.0334C18.1504 20.0115 17.8473 19.8542 17.5632 19.5613L12.9511 14.8068L8.27403 19.3437C7.98118 19.6278 7.68204 19.7675 7.3766 19.7629C7.07117 19.7582 6.78476 19.6181 6.5174 19.3425C6.25003 19.0668 6.11866 18.7763 6.12331 18.4709C6.12795 18.1654 6.2767 17.8707 6.56955 17.5866L11.2466 13.0497L6.78484 8.45016C6.48405 8.14008 6.33598 7.83232 6.34062 7.52688C6.34527 7.22145 6.50263 6.91834 6.81271 6.61755C7.10556 6.33347 7.39609 6.2021 7.6843 6.22346C7.98973 6.2281 8.29284 6.38546 8.59364 6.69554L13.0554 11.295L17.7324 6.75812C18.0252 6.47404 18.3244 6.33432 18.6298 6.33896C18.9353 6.34361 19.2217 6.48374 19.489 6.75937C19.7564 7.03499 19.8878 7.32552 19.8831 7.63096C19.8785 7.93639 19.7297 8.23115 19.4369 8.51523L14.7598 13.0522L19.372 17.8067C19.6561 18.0996 19.8041 18.4073 19.8162 18.73C19.8288 19.0187 19.68 19.3135 19.37 19.6142Z"
          fill="currentColor"
        />
      </svg>
    ),
    play_icon: (
      <svg
        width="44px"
        height="44px"
        viewBox="0 0 24 24"
        fill="#267c26"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" style={{ strokeWidth: "0" }}></g>
        <g
          id="SVGRepo_tracerCarrier"
          style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              stroke: "currentColor",
              strokeWidth: "2",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }}
            d="M10.715 6.36694L16.4 10.6639C16.7719 10.9289 16.9927 11.3573 16.9927 11.8139C16.9927 12.2706 16.7719 12.699 16.4 12.9639L10.71 17.6639C10.2297 18.0453 9.5794 18.1339 9.01458 17.8948C8.44975 17.6558 8.06062 17.1273 8.00003 16.5169V7.51694C8.05845 6.90422 8.44802 6.37281 9.01478 6.13275C9.58154 5.89269 10.2343 5.9826 10.715 6.36694Z"
          ></path>
        </g>
      </svg>
    ),
    pause_icon: (
      <svg
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        fill="red"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="SVGRepo_bgCarrier" style={{ strokeWidth: "0" }}></g>
        <g
          id="SVGRepo_tracerCarrier"
          style={{ strokeLinecap: "round", strokeLinejoin: "round" }}
        ></g>
        <g id="SVGRepo_iconCarrier">
          <path
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              stroke: "currentColor",
              strokeWidth: "0",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }}
            d="M7.00002 9.125V14.875C6.99816 15.1715 7.11417 15.4566 7.32252 15.6676C7.53087 15.8786 7.81451 15.9981 8.11102 16H9.22202C9.51854 15.9981 9.80217 15.8786 10.0105 15.6676C10.2189 15.4566 10.3349 15.1715 10.333 14.875V9.125C10.3349 8.82849 10.2189 8.54338 10.0105 8.3324C9.80217 8.12142 9.51854 8.00185 9.22202 8H8.11102C7.81451 8.00185 7.53087 8.12142 7.32252 8.3324C7.11417 8.54338 6.99816 8.82849 7.00002 9.125Z"
          ></path>
          <path
            d="M13.667 9.125V14.875C13.6652 15.1715 13.7812 15.4566 13.9895 15.6676C14.1979 15.8786 14.4815 15.9981 14.778 16H15.889C16.1855 15.9981 16.4692 15.8786 16.6775 15.6676C16.8859 15.4566 17.0019 15.1715 17 14.875V9.125C17.0019 8.82849 16.8859 8.54338 16.6775 8.3324C16.4692 8.12142 16.1855 8.00185 15.889 8H14.778C14.4815 8.00185 14.1979 8.12142 13.9895 8.3324C13.7812 8.54338 13.6652 8.82849 13.667 9.125V9.125Z"
            stroke="currentColor"
            style={{
              fillRule: "evenodd",
              clipRule: "evenodd",
              strokeWidth: "0",
              strokeLinecap: "round",
              strokeLinejoin: "round"
            }}
          ></path>
        </g>
      </svg>
    ),
    eye_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className=""
        style={{ width: "24px" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z"
        />
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        />
      </svg>
    ),
    eye_slash_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={1.5}
        stroke="currentColor"
        className=""
        style={{ width: "24px" }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M3.98 8.223A10.477 10.477 0 0 0 1.934 12C3.226 16.338 7.244 19.5 12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.451 10.451 0 0 1 12 4.5c4.756 0 8.773 3.162 10.065 7.498a10.522 10.522 0 0 1-4.293 5.774M6.228 6.228 3 3m3.228 3.228 3.65 3.65m7.894 7.894L21 21m-3.228-3.228-3.65-3.65m0 0a3 3 0 1 0-4.243-4.243m4.242 4.242L9.88 9.88"
        />
      </svg>
    ),
    info_icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="13"
        height="13"
        viewBox="0 0 512 512"
      >
        <path
          d="M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm19 304h-38.2V207.9H275V352zm-19.1-159.8c-11.3 0-20.5-8.6-20.5-20s9.3-19.9 20.5-19.9c11.4 0 20.7 8.5 20.7 19.9s-9.3 20-20.7 20z"
          fill="currentColor"
        />
      </svg>
    )
  };

  const handleIconMouseEnter = (value, text) => {
    setHoverText([value, text]);
  };

  const handleIconMouseLeave = () => {
    setHoverText("");
  };

  // useEffect(() => {
  //   loadMaaiaInfo();
  // }, [client_data]);

  function loadMaaiaInfo() {
    if (client_data) {
      const agents = client_data.agents.map((element) => JSON.parse(element));
      const first_agent = agents[0];
      if (first_agent) {
        setAgent(first_agent);
        fecthFullTime(first_agent.agent_work_times);

        // setTimesByDay(first_agent.agent_work_times); à redefinir dans la base de données
        // changeLanguageAction(first_agent.agent_language[0].code, first_agent.agent_language[0].name);
        setAgentTimezone(first_agent.agent_timezone);

        setAgentModalInfo(first_agent);
        setTimesByDay(first_agent.agent_work_times);
        setToneSelected(first_agent.agent_tone_communication);
        setSelectedGreeting(first_agent.agent_greeting ?? []);
        setSelectedFormula(first_agent.agent_polite_formula ?? []);
        console.log({ agentModal: agentModalInfo });
      }
    } else {
      console.log({ agentModal: "no" });
    }
  }

  function fecthFullTime(agent_work_times) {
    setFullTime(
      {
        week:
          agent_work_times["week"].open === 0 &&
          agent_work_times["week"].close === 24
      },
      {
        week_end:
          agent_work_times["week_end"].open === 0 &&
          agent_work_times["week_end"].close === 24
      }
    );
  }

  const handleKeyDown = (event) => {
    if (!inputValue) return;
    switch (event.key) {
      case "Enter":
      case "Tab":
        setMaaiaNames((prev) => [...prev, createOption(inputValue)]);
        setInputValue("");
        event.preventDefault();
        break;
      default:
    }
  };

  return (
    <React.Fragment>
      <div
        className="position-fixed bottom-0 end-0 p-3 font-primary"
        style={{ zIndex: "1005" }}
      >
        <CustomToast
          isOpen={toast}
          toggle={toggleToast}
          message={{
            title: updateUserPrefsLoading.title,
            body: updateUserPrefsLoading.message,
            key: updateUserPrefsLoading.key
          }}
        />
      </div>

      <Container fluid={false} style={{ paddingTop: "10px " }}>
        {/* Calculator */}
        <CalculatorModal
          isOpen={show_calculator}
          toggle={onShowCalculator}
          upgrade_downgrade={true}
        />
      </Container>

      {/* Phone Number Modal */}
      <Modal
        isOpen={updatePhoneModal}
        toggle={tog_phone_modal}
        centered
        className="help-page-modal"
      >
        <ModalBody>
          <Button
            className="close_button "
            style={{
              backgroundColor: "transparent",
              border: "none",
              padding: "0px",
              float: "right"
            }}
            onClick={tog_phone_modal}
          >
            {svgs.close_icon}
          </Button>
          <h1
            className="modal_title font-primary"
            style={{
              marginTop: "8%",
              marginBottom: "6%",
              textTransform: "none",
              fontSize: "14px"
            }}
          >
            {props.t(
              userPrefs.phone
                ? "Entrez votre nouveau numéro de téléphone"
                : "Ajoutez votre numéro de téléphone"
            )}
          </h1>
          <Row
            className="gap-4 mb-5 "
            style={{ paddingLeft: "8%", paddingRight: "8%" }}
          >
            <Form
              className="form-horizontal col-10 mx-auto font-primary"
              onSubmit={(e) => {
                e.preventDefault();
                onRequestIsLoading(true);
                if (userDetails.phone.startsWith(phoneDialCode)) {
                  updateUserPhone(userDetails.phone, password);
                } else {
                  updateUserPhone(phoneDialCode + userDetails.phone, password);
                }
                return false;
              }}
            >
              <div>
                <label
                  className="font-primary font-primary"
                  style={{ fontSize: "14px" }}
                >
                  {props.t("Téléphone")}
                </label>
                <div className="form-control p-0 font-primary">
                  <IntlTelInput
                    containerClassName="intl-tel-input col-xxl-12"
                    inputClassName="form-control"
                    formatOnInit={false}
                    value={userDetails.phone}
                    onPhoneNumberChange={(status, phoneNumber, country) => {
                      setPhone_status(status);
                      setPhoneDialCode("+" + country.dialCode);
                      setUserDetails({
                        ...userDetails,
                        phone: phoneNumber.replace(/ /g, "")
                      });
                    }}
                  />
                </div>
              </div>
              <Label
                className="font-primary mt-4 font-primary"
                style={{ fontSize: "14px" }}
              >
                {props.t("Confirmer Mot de Passe")}
              </Label>
              <InputGroup>
                <Input
                  name="password"
                  value={password}
                  type={isPasswordHidden ? "password" : "text"}
                  placeholder={props.t("Entrer Mot de passe")}
                  onChange={(e) => onPasswordChange(e.target.value)}
                  // onClick={(e) => setValidation({ ...validation, touched: true })}
                  // invalid={
                  //   validation.touched && validation.errors ? true
                  //     : false
                  // }
                />
                {/* {validation.touched && validation.errors ? (
                <FormFeedback type="invalid"><div> {validation.errors} </div></FormFeedback>
              ) : null} */}
                <InputGroupText
                  style={{
                    backgroundColor: "transparent",
                    border: "none",
                    padding: "0"
                  }}
                >
                  <button
                    className="btn h-100 form-control "
                    type="button"
                    onClick={togglePasswordVisibility}
                    style={{
                      borderTopLeftRadius: "0",
                      borderBottomLeftRadius: "0"
                    }}
                  >
                    {isPasswordHidden ? svgs.eye_icon : svgs.eye_slash_icon}
                  </button>
                </InputGroupText>
              </InputGroup>

              <button
                type={phone_status && password ? "submit" : "button"}
                className="inputCustom__Button mt-5 font-primary"
                disabled={!phone_status && !password}
                style={{
                  border: "none",
                  cursor: phone_status && password ? "pointer" : "not-allowed"
                }}
                // onClick={}
              >
                {requestIsLoading ? (
                  props.t("Chargement") + "..."
                ) : (
                  <>
                    {userPrefs.telephone ? (
                      props.t("Modifier")
                    ) : (
                      <>
                        {svgs.plus_icon} {props.t("Ajouter")}
                      </>
                    )}
                  </>
                )}
              </button>
            </Form>
          </Row>
        </ModalBody>
        <div
          className="position-fixed bottom-0 end-0 p-3"
          style={{ zIndex: "1005" }}
        >
          <CustomToast
            isOpen={validation.errors}
            toggle={togglePhoneToast}
            message={{
              title: props.t("Echec"),
              body: validation.errors,
              key: "danger"
            }}
          />
        </div>
      </Modal>

      {passwordModal && (
        <UpdatePassword
          passwordModal={passwordModal}
          tog_password_modal={tog_password_modal}
          getUserAccount={getUserAccount()}
        />
      )}

      <div className="page-content" style={{ paddingLeft: "2em" }}>
        <div
          className="settings-content"
          style={{
            position: "relative"
          }}
        >
          <div
            className="menuTopScroll"
            style={{
              position: "fixed",
              zIndex: 1000,
              width: "calc(100% - 80px)"
            }}
          >
            <Col xs="12" style={{ paddingBottom: "0" }}>
              <div
                className="page-title-box d-sm-flex align-items-center justify-content-between"
                style={{ paddingLeft: "0", paddingRight: "0" }}
              >
                <h4
                  className="page-title font-primary"
                  style={{ fontSize: "", marginTop: "18px" }}
                >
                  {props.t("Paramètres")}
                </h4>
              </div>
            </Col>
            {/* MENU */}
            {/* <div className="col-12" style={{
                         display: "flex",
                         justifyContent: "center",
                         alignItems: "center",
                    
                         width:"100%"
                      }}> */}

            <Col md="12">
              {/* Nav Bar */}
              <Row>
                <Col md="12">
                  <Card
                    className="settings-menu"
                    style={{
                      display: "flex",
                      backgroundColor: "transparent",
                      boxShadow: "none",
                      alignContent: "center",
                      alignItems: "center",
                      marginBottom: "0px",
                      justifyContent: "center"
                    }}
                  >
                    <CardBody style={{ padding: "0px" }}>
                      <Nav
                        pills
                        className="flex-row"
                        style={{ height: "fit-content", width: "fit-content" }}
                      >
                        <NavItem>
                          <NavLink
                            id="v-pills-left-setting-tab"
                            style={{
                              cursor: "pointer"
                              // pointerEvents: client_data && client_data.plan_id && client_data.plan_id === "free" ? "none" : "auto",
                            }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "5"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("5");
                              setMaaiaPageRender(true);
                            }}
                          >
                            <div className="d-flex align-items-center flex-wrap gap-2">
                              {/* <IconParkSolidRobotOne height="1.2rem" /> */}
                              <div
                                className="col-auto"
                                style={{
                                  height: "24px",
                                  width: "24px",
                                  backgroundImage:
                                    "url(" + synibix_icon_buble_chat + ")",
                                  backgroundSize: "contain"
                                }}
                              ></div>
                              <span className="font-primary">
                                {props.t("Agent Synibox")}
                              </span>

                              {/* <span className="ps-1" width={"18px"} height={"18px"} style={{ color: "red !important" }}>
                                  <svg
                                    class="w-6 h-6 text-gray-800 dark:text-white"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="24"
                                    height="24"
                                    fill="currentColor"
                                    viewBox="0 0 24 24">
                                    <path
                                      fill-rule="evenodd"
                                      d="M8 10V7a4 4 0 1 1 8 0v3h1a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h1Zm2-3a2 2 0 1 1 4 0v3h-4V7Zm2 6a1 1 0 0 1 1 1v3a1 1 0 1 1-2 0v-3a1 1 0 0 1 1-1Z"
                                      clip-rule="evenodd"
                                    />
                                  </svg>
                                </span> */}
                            </div>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="v-pills-left-home-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "1"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("1");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                width="15"
                                height="15"
                                style={{ marginTop: "3px" }}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19.1471 4.73876C19.19 4.18931 19.0044 3.6465 18.6339 3.23846C18.4238 3.00706 18.1159 2.82927 17.5 2.47368C16.8841 2.11809 16.5762 1.9403 16.2707 1.87406C15.7321 1.75725 15.1692 1.86787 14.7148 2.1798C14.4572 2.3567 14.2394 2.6378 13.8039 3.2C13.3831 3.74315 12.7031 4.0014 12.0161 4.00005C12.0107 4.00004 12.0054 4.00004 12 4.00004C11.9946 4.00004 11.9891 4.00004 11.9837 4.00005C11.2967 4.00142 10.6168 3.74321 10.1961 3.20015C9.76058 2.63795 9.54281 2.35684 9.28515 2.17995C8.8308 1.86802 8.26788 1.7574 7.72928 1.87421C7.42384 1.94045 7.11589 2.11824 6.5 2.47383C5.8841 2.82942 5.57615 3.00721 5.36607 3.23861C4.99561 3.64664 4.80995 4.18946 4.85291 4.7389C4.87727 5.05049 5.01183 5.37963 5.28093 6.0379C5.54099 6.67405 5.42354 7.39207 5.07823 7.98627C5.07263 7.99592 5.06705 8.00557 5.06149 8.01524C4.71924 8.60989 4.15689 9.06955 3.47708 9.16226C2.77242 9.25835 2.4201 9.30639 2.13807 9.44108C1.64076 9.6786 1.2635 10.1108 1.09535 10.6356C1 10.9333 1 11.2889 1 12C1 12.7112 1 13.0668 1.09535 13.3644C1.2635 13.8893 1.64076 14.3215 2.13807 14.559C2.4201 14.6937 2.77242 14.7417 3.47708 14.8378C4.1569 14.9305 4.71924 15.3902 5.06149 15.9848C5.06705 15.9945 5.07264 16.0042 5.07824 16.0138C5.42354 16.608 5.541 17.326 5.28094 17.9621C5.01183 18.6204 4.87728 18.9496 4.85291 19.2612C4.80995 19.8106 4.99561 20.3534 5.36607 20.7615C5.57616 20.9929 5.8841 21.1707 6.5 21.5262C7.11589 21.8818 7.42384 22.0596 7.72928 22.1259C8.26788 22.2427 8.8308 22.132 9.28515 21.8201C9.54281 21.6432 9.76058 21.3621 10.1961 20.7999C10.6168 20.2569 11.2967 19.9986 11.9837 20C11.9891 20 11.9946 20 12 20C12.0054 20 12.0107 20 12.0161 20C12.7031 19.9987 13.3831 20.2569 13.8039 20.8001C14.2394 21.3623 14.4572 21.6434 14.7148 21.8203C15.1692 22.1322 15.7321 22.2428 16.2707 22.126C16.5762 22.0598 16.8841 21.882 17.5 21.5264C18.1159 21.1708 18.4238 20.993 18.6339 20.7616C19.0044 20.3536 19.19 19.8108 19.1471 19.2613C19.1227 18.9497 18.9882 18.6206 18.719 17.9623C18.459 17.3261 18.5764 16.608 18.9218 16.0138C18.9274 16.0041 18.9329 15.9945 18.9385 15.9849C19.2808 15.3902 19.8431 14.9305 20.5229 14.8378C21.2276 14.7417 21.5799 14.6937 21.8619 14.559C22.3592 14.3215 22.7365 13.8893 22.9046 13.3644C23 13.0668 23 12.7112 23 12C23 11.2889 23 10.9333 22.9046 10.6356C22.7365 10.1108 22.3592 9.6786 21.8619 9.44109C21.5799 9.30639 21.2276 9.25835 20.5229 9.16226C19.8431 9.06955 19.2808 8.60989 18.9385 8.01523C18.933 8.00557 18.9274 7.99593 18.9218 7.9863M12 9C13.6569 9 15 10.3431 15 12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12C9 11.6494 9.06015 11.3128 9.17071 11"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                              <span>{props.t("General")} </span>
                            </div>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="v-pills-left-home-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "10"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("10");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                style={{ marginTop: "3px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="1.5"
                                  d="M12 10.174Q14.649 5.999 16.648 6c2 0 3.263 2.213 4 5.217c.704 2.869.5 6.783-2 6.783c-1.114 0-2.648-1.565-4.148-3.652a27.6 27.6 0 0 1-2.5-4.174m0 0Q9.351 5.999 7.352 6c-2 0-3.263 2.213-4 5.217c-.704 2.869-.5 6.783 2 6.783C6.466 18 8 16.435 9.5 14.348q1.5-2.087 2.5-4.174"
                                />
                              </svg>
                              <span>{props.t("Facebook")} </span>
                            </div>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="v-pills-left-home-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "11"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("11");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                style={{ marginTop: "3px" }}
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                              >
                                <path
                                  fill="currentColor"
                                  d="M19.05 4.91A9.82 9.82 0 0 0 12.04 2c-5.46 0-9.91 4.45-9.91 9.91c0 1.75.46 3.45 1.32 4.95L2.05 22l5.25-1.38c1.45.79 3.08 1.21 4.74 1.21c5.46 0 9.91-4.45 9.91-9.91c0-2.65-1.03-5.14-2.9-7.01m-7.01 15.24c-1.48 0-2.93-.4-4.2-1.15l-.3-.18l-3.12.82l.83-3.04l-.2-.31a8.26 8.26 0 0 1-1.26-4.38c0-4.54 3.7-8.24 8.24-8.24c2.2 0 4.27.86 5.82 2.42a8.18 8.18 0 0 1 2.41 5.83c.02 4.54-3.68 8.23-8.22 8.23m4.52-6.16c-.25-.12-1.47-.72-1.69-.81c-.23-.08-.39-.12-.56.12c-.17.25-.64.81-.78.97c-.14.17-.29.19-.54.06c-.25-.12-1.05-.39-1.99-1.23c-.74-.66-1.23-1.47-1.38-1.72c-.14-.25-.02-.38.11-.51c.11-.11.25-.29.37-.43s.17-.25.25-.41c.08-.17.04-.31-.02-.43s-.56-1.34-.76-1.84c-.2-.48-.41-.42-.56-.43h-.48c-.17 0-.43.06-.66.31c-.22.25-.86.85-.86 2.07s.89 2.4 1.01 2.56c.12.17 1.75 2.67 4.23 3.74c.59.26 1.05.41 1.41.52c.59.19 1.13.16 1.56.1c.48-.07 1.47-.6 1.67-1.18c.21-.58.21-1.07.14-1.18s-.22-.16-.47-.28"
                                />
                              </svg>
                              <span>{props.t("WhatsApp")} </span>
                            </div>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="v-pills-left-home-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "2"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("2");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                width="15"
                                height="15"
                                style={{ marginTop: "3px" }}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M22 9.5V9V9C22 8.07099 22 7.60649 21.9384 7.21783C21.5996 5.07837 19.9216 3.40042 17.7822 3.06156C17.3935 3 16.929 3 16 3H10C7.19974 3 5.79961 3 4.73005 3.54497C3.78924 4.02433 3.02433 4.78924 2.54497 5.73005C2 6.79961 2 8.19974 2 11V13C2 15.8003 2 17.2004 2.54497 18.27C3.02433 19.2108 3.78924 19.9757 4.73005 20.455C5.79961 21 7.19974 21 10 21H16C16.929 21 17.3935 21 17.7822 20.9384C19.9216 20.5996 21.5996 18.9216 21.9384 16.7822C22 16.3935 22 15.929 22 15V15V14.5M18 8L17 8.66667L16.4376 9.0416C14.8338 10.1108 14.0319 10.6454 13.1652 10.8531C12.3992 11.0366 11.6008 11.0366 10.8348 10.8531C9.96808 10.6454 9.16618 10.1108 7.5624 9.0416L7 8.66667L6 8"
                                  stroke="currentColor"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                />
                              </svg>
                              <span>{props.t("E-mail")}</span>
                            </div>
                          </NavLink>
                        </NavItem>

                        <NavItem>
                          <NavLink
                            id="v-pills-left-messages-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "4"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("4");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                width="15"
                                height="15"
                                style={{ marginTop: "3px" }}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M14.5 22H16.8C18.5673 22 20 20.5673 20 18.8V18.8C20 16.149 17.851 14 15.2 14H8.8C6.14903 14 4 16.149 4 18.8V18.8C4 20.5673 5.43269 22 7.2 22H9.5M16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6Z"
                                  stroke="#2F384C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>

                              <span>{props.t("Profile")}</span>
                            </div>
                          </NavLink>
                        </NavItem>

                        {process.env.REACT_APP_MAAIA_ENV !== "production" && (
                          <NavItem>
                            <NavLink
                              id="v-pills-left-setting-tab"
                              style={{ cursor: "pointer" }}
                              className={classnames({
                                active: verticalActiveTabWithIcon === "6"
                              })}
                              onClick={() => {
                                toggleVerticalIcon("6");
                              }}
                            >
                              <div className="d-flex flex-wrap gap-2">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="15"
                                  height="15"
                                  style={{ marginTop: "3px" }}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  stroke="currentColor"
                                  stroke-width="2"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                  class="icon icon-tabler icons-tabler-outline icon-tabler-users"
                                >
                                  <path
                                    stroke="none"
                                    d="M0 0h24v24H0z"
                                    fill="none"
                                  />
                                  <path d="M9 7m-4 0a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
                                  <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
                                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                                  <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
                                </svg>

                                <span> {props.t("Collaborateurs")}</span>
                              </div>
                            </NavLink>
                          </NavItem>
                        )}
                        {process.env.REACT_APP_MAAIA_ENV !== "production" && (
                          <NavItem>
                            <NavLink
                              id="v-pills-left-setting-tab"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                {
                                  active: verticalActiveTabWithIcon === "7"
                                },
                                "font-primary"
                              )}
                              onClick={() => {
                                toggleVerticalIcon("7");
                              }}
                            >
                              <div className="d-flex flex-wrap gap-2">
                                <svg
                                  width="15"
                                  height="15"
                                  style={{ marginTop: "3px" }}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M6.5 14C6.5 14.2761 6.27614 14.5 6 14.5C5.72386 14.5 5.5 14.2761 5.5 14M6.5 14C6.5 13.7239 6.27614 13.5 6 13.5C5.72386 13.5 5.5 13.7239 5.5 14M6.5 14H5.5M6.5 18C6.5 18.2761 6.27614 18.5 6 18.5C5.72386 18.5 5.5 18.2761 5.5 18M6.5 18C6.5 17.7239 6.27614 17.5 6 17.5C5.72386 17.5 5.5 17.7239 5.5 18M6.5 18H5.5M10.5 14C10.5 14.2761 10.2761 14.5 10 14.5C9.72386 14.5 9.5 14.2761 9.5 14M10.5 14C10.5 13.7239 10.2761 13.5 10 13.5C9.72386 13.5 9.5 13.7239 9.5 14M10.5 14H9.5M10.5 18C10.5 18.2761 10.2761 18.5 10 18.5C9.72386 18.5 9.5 18.2761 9.5 18M10.5 18C10.5 17.7239 10.2761 17.5 10 17.5C9.72386 17.5 9.5 17.7239 9.5 18M10.5 18H9.5M14.5 14C14.5 14.2761 14.2761 14.5 14 14.5C13.7239 14.5 13.5 14.2761 13.5 14M14.5 14C14.5 13.7239 14.2761 13.5 14 13.5C13.7239 13.5 13.5 13.7239 13.5 14M14.5 14H13.5M14.5 18C14.5 18.2761 14.2761 18.5 14 18.5C13.7239 18.5 13.5 18.2761 13.5 18M14.5 18C14.5 17.7239 14.2761 17.5 14 17.5C13.7239 17.5 13.5 17.7239 13.5 18M14.5 18H13.5M22 10H18M18 7H18.8C19.9201 7 20.4802 7 20.908 7.21799C21.2843 7.40973 21.5903 7.71569 21.782 8.09202C22 8.51984 22 9.07989 22 10.2V13.8C22 14.9201 22 15.4802 21.782 15.908C21.5903 16.2843 21.2843 16.5903 20.908 16.782C20.4802 17 19.9201 17 18.8 17H18M11.5 5H12H13.4C13.9601 5 14.2401 5 14.454 5.10899C14.6422 5.20487 14.7951 5.35785 14.891 5.54601C15 5.75992 15 6.03995 15 6.6V8.4C15 8.96005 15 9.24008 14.891 9.45399C14.7951 9.64215 14.6422 9.79513 14.454 9.89101C14.2401 10 13.9601 10 13.4 10H6.6C6.03995 10 5.75992 10 5.54601 9.89101C5.35785 9.79513 5.20487 9.64215 5.10899 9.45399C5 9.24008 5 8.96005 5 8.4V6.6C5 6.03995 5 5.75992 5.10899 5.54601C5.20487 5.35785 5.35785 5.20487 5.54601 5.10899C5.75992 5 6.03995 5 6.6 5H8H8.5M2 12V17.2C2 18.8802 2 19.7202 2.32698 20.362C2.6146 20.9265 3.07354 21.3854 3.63803 21.673C4.27976 22 5.11984 22 6.8 22H13.2C14.8802 22 15.7202 22 16.362 21.673C16.9265 21.3854 17.3854 20.9265 17.673 20.362C18 19.7202 18 18.8802 18 17.2V6.8C18 5.11984 18 4.27976 17.673 3.63803C17.3854 3.07354 16.9265 2.6146 16.362 2.32698C15.7202 2 14.8802 2 13.2 2H6.8C5.11984 2 4.27976 2 3.63803 2.32698C3.07354 2.6146 2.6146 3.07354 2.32698 3.63803C2 4.27976 2 5.11984 2 6.8V7.5V8"
                                    stroke="#2F384C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>

                                <span>{props.t("Facturation")} </span>
                              </div>
                            </NavLink>
                          </NavItem>
                        )}

                        <NavItem>
                          <NavLink
                            id="v-pills-left-setting-tab"
                            style={{ cursor: "pointer" }}
                            className={classnames(
                              {
                                active: verticalActiveTabWithIcon === "8"
                              },
                              "font-primary"
                            )}
                            onClick={() => {
                              toggleVerticalIcon("8");
                            }}
                          >
                            <div className="d-flex flex-wrap gap-2">
                              <svg
                                width="15"
                                height="15"
                                style={{ marginTop: "3px" }}
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M7.99999 19.5455C8.65859 21.0273 10.3784 22 12 22C13.6216 22 15.3414 21.0273 16 19.5455M18 11.1902C18 12.0239 18.3538 12.8185 18.9735 13.3762L20.0814 14.3733C21.404 15.5636 20.982 17.7338 19.3099 18.3419L19.0989 18.4186C14.5132 20.0861 9.4868 20.0861 4.90108 18.4186L4.69008 18.3419C3.01796 17.7338 2.59603 15.5636 3.91853 14.3733L5.02646 13.3762C5.64614 12.8185 5.99999 12.0239 5.99999 11.1902V8C5.99999 4.68629 8.68628 2 12 2C14.973 2 17.441 4.16229 17.917 7"
                                  stroke="#2F384C"
                                  strokeWidth="1.5"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>

                              <span>{props.t("Notifications")}</span>
                            </div>
                          </NavLink>
                        </NavItem>
                        {userInfos && userInfos.prefs["owner"] && (
                          <NavItem>
                            <NavLink
                              id="v-pills-left-setting-tab"
                              style={{ cursor: "pointer" }}
                              className={classnames(
                                {
                                  active: verticalActiveTabWithIcon === "9"
                                },
                                "font-primary"
                              )}
                              onClick={() => {
                                toggleVerticalIcon("9");
                              }}
                            >
                              <div className="d-flex flex-wrap gap-2">
                                <svg
                                  width="15"
                                  height="15"
                                  style={{ marginTop: "3px" }}
                                  viewBox="0 0 24 24"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M9.00024 20.0002H15.0002M19.0002 20.0002H22.0002M16.0002 12H22.0002H9.00024H12.0002M9.00024 4.00018H15.0002M22.0002 4.00018H19.0002M3.50024 4.00018C3.50024 4.27633 3.27639 4.50018 3.00024 4.50018C2.7241 4.50018 2.50024 4.27633 2.50024 4.00018M3.50024 4.00018C3.50024 3.72404 3.27639 3.50018 3.00024 3.50018C2.7241 3.50018 2.50024 3.72404 2.50024 4.00018M3.50024 4.00018H2.50024M3.50024 12.0002C3.50024 12.2763 3.27639 12.5002 3.00024 12.5002C2.7241 12.5002 2.50024 12.2763 2.50024 12.0002M3.50024 12.0002C3.50024 11.724 3.27639 11.5002 3.00024 11.5002C2.7241 11.5002 2.50024 11.724 2.50024 12.0002M3.50024 12.0002H2.50024M3.50024 20.0002C3.50024 20.2763 3.27639 20.5002 3.00024 20.5002C2.7241 20.5002 2.50024 20.2763 2.50024 20.0002M3.50024 20.0002C3.50024 19.724 3.27639 19.5002 3.00024 19.5002C2.7241 19.5002 2.50024 19.724 2.50024 20.0002M3.50024 20.0002H2.50024"
                                    stroke="#2F384C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>

                                <span>{props.t("Logs")}</span>
                              </div>
                            </NavLink>
                          </NavItem>
                        )}
                      </Nav>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              {/* Content */}
            </Col>
            {/* </div> */}
          </div>

          <Col xl={12} style={{ marginTop: "100px" }}>
            <Row>
              <Col md="12" style={{}}>
                <TabContent
                  activeTab={verticalActiveTabWithIcon}
                  className="text-muted mt-4 mt-md-0"
                >
                  {/* Agents Synibox */}
                  <TabPane
                    tabId="5"
                    style={{
                      color: "black",
                      backgroundColor: "inherit",
                      paddingLeft: "8%",
                      paddingRight: "8%"
                    }}
                  >
                    {maaiaPageRender ? (
                      <MaaiaPage />
                    ) : (
                      <div className="font-primary">
                        {props.t("Chargement...")}
                      </div>
                    )}

                    {/* {
                    MaaiaPage(
                      client_data,
                      agentModalInfo,
                      props,
                      handleIconMouseEnter,
                      handleIconMouseLeave,
                      svgs,
                      hoverText,
                      inputValue,
                      setMaaiaNames,
                      setInputValue,
                      handleKeyDown,
                      maaiaNames,
                      nameInputTouched,
                      number_of_languages,
                      onShowCalculator,
                      numberOfLanguages,
                      setAgentModalInfo,
                      optionGroup2,
                      animatedComponents,
                      toneSelected,
                      setToneSelected,
                      agentSelectedTimezone,
                      setAgentTimezone,
                      setUtc,
                      timezones,
                      marginPolite,
                      selectedGreeting,
                      setSelectedGreeting,
                      greetings,
                      animated2Components,
                      selectedFormula,
                      setSelectedFormula,
                      formulas,
                      animated3Components,
                      fullTime,
                      setFullTime,
                      setTimesByDay,
                      daysOfWeek,
                      timesByDay,
                      handleSwitchAiBehavior,
                      ai_behavior,
                      updateAgentLoading,
                      handleModalAgentUpdate,
                      setNameInputTouched
                    )} */}
                  </TabPane>

                  <TabPane tabId="1">
                    <General />
                  </TabPane>

                  <TabPane tabId="10">
                    <FacebookSettings
                    // fb_selected_page={fb_selected_page}
                    // fb_selected_pages={fb_selected_pages}
                    // isFbConnected={isFbConnected}
                    // loading={loading}
                    // fb_pages={fb_pages}
                    // setIsFbConnected={setIsFbConnected}
                    // setFBSelectedPage={setFBSelectedPage}
                    // setFBSelectedPages={setFBSelectedPages}
                    // setFBPages={setFBPages}
                    />
                  </TabPane>

                  <TabPane tabId="11">
                    <WhatsappSettings />
                  </TabPane>

                  <TabPane tabId="2">
                    <SettingEmailConfig
                      toggleVerticalIcon={toggleVerticalIcon}
                      setMaaiaPageRender={setMaaiaPageRender}
                    />
                  </TabPane>
                  {/* <TabPane tabId="3">
                  <p> Chat</p>
                </TabPane> */}

                  <TabPane
                    tabId="4"
                    className="profile"
                    style={{ paddingLeft: "8%", paddingRight: "8%" }}
                  >
                    <Row className="align-items-center justify-content-between flex-row mb-3">
                      <div style={{ width: "fit-content" }}>
                        <h3
                          className="section-title mb-0 font-primary"
                          style={{ fontSize: "18px" }}
                        >
                          {props.t("Profile")}
                        </h3>
                      </div>
                    </Row>
                    <div className="inter-ligne"></div>

                    {/* Profile Content */}
                    <Row>
                      <Col xl={2}>
                        <h6
                          className="inner_section_title_1 font-primary"
                          style={{ fontSize: "14px" }}
                        >
                          {props.t("Détails")}
                        </h6>
                      </Col>
                      <Col xl={10}>
                        <Card>
                          <CardBody>
                            <Row>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Prénom")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t("Prénom")}
                                    value={userDetails.first_name}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        first_name: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Nom de famille")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t("Nom de famille")}
                                    value={userDetails.last_name}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        last_name: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <div className="mt-3 mb-3 simple-text font-primary">
                              {props.t("profile_details_subtitle")}
                            </div>
                            <Row className="my-3">
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Nom de l’entreprise")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez le nom de l’entreprise"
                                    )}
                                    value={userDetails.company_name}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        company_name: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Numéro SIREN/SIRET")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez votre numéro SIREN/SIRET"
                                    )}
                                    value={userDetails.vat_number}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        vat_number: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="my-3">
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Adresse") + " 1"}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez votre adresse"
                                    )}
                                    value={userDetails.address1}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        address1: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Adresse") + " 2"}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez votre adresse"
                                    )}
                                    value={userDetails.address2}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        address2: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              {/* <Col xl={6}>
                              <div>
                                <label className="font-primary">{props.t("Genre")}</label>
                                <Dropdown isOpen={singlebtn} toggle={() => setSinglebtn(!singlebtn)} className="">
                                  <DropdownToggle className="form-control d-flex align-items-center" tag="button" id="">
                                    {props.t(userDetails.gender)}
                                  </DropdownToggle>

                                  <DropdownMenu className="dropdown-menu dropdown-menu-lg dropdown-menu-start">
                                    <DropdownItem
                                      onClick={() => {
                                        setUserDetails({
                                          ...userDetails,
                                          gender: "Homme",
                                        });
                                      }}>
                                      {props.t("Homme")}
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setUserDetails({
                                          ...userDetails,
                                          gender: "Femme",
                                        });
                                      }}>
                                      {props.t("Femme")}
                                    </DropdownItem>
                                    <DropdownItem
                                      onClick={() => {
                                        setUserDetails({
                                          ...userDetails,
                                          gender: "Autre",
                                        });
                                      }}>
                                      {props.t("Autre")}
                                    </DropdownItem>
                                  </DropdownMenu>
                                </Dropdown>
                              </div>
                            </Col> */}
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Pays")}
                                  </label>
                                  <ReactFlagsSelect
                                    selectButtonClassName="form-control d-flex"
                                    searchable={true}
                                    placeholder={props.t(
                                      "Sélectionnez votre pays."
                                    )}
                                    searchPlaceholder={props.t("Recherche")}
                                    selected={
                                      userDetails.country
                                        ? userDetails.country.toUpperCase()
                                        : "FR"
                                    }
                                    onSelect={(code) => {
                                      setUserDetails({
                                        ...userDetails,
                                        country: code.toLowerCase()
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Etat/Région")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez votre état/région"
                                    )}
                                    value={userDetails.state}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        state: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                            </Row>
                            <Row className="my-3">
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Ville")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t("Entrez votre ville")}
                                    value={userDetails.city}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        city: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}>
                                <div>
                                  <label
                                    className="font-primary"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {props.t("Code Postal")}
                                  </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    placeholder={props.t(
                                      "Entrez votre code Postal"
                                    )}
                                    value={userDetails.zip}
                                    onChange={(e) => {
                                      setUserDetails({
                                        ...userDetails,
                                        zip: e.target.value
                                      });
                                    }}
                                  />
                                </div>
                              </Col>
                              <Col xl={6}></Col>
                            </Row>

                            <div className="mt-3 mb-1 w-100 d-flex justify-content-end">
                              <button
                                onClick={(e) => {
                                  saveUserPrefsActions();
                                }}
                                style={{
                                  backgroundColor: "#563bff",
                                  borderRadius: "20px"
                                }}
                                className="view-button simple-text font-primary"
                              >
                                {updateUserPrefsLoading.loading && (
                                  <span
                                    className="spinner-border spinner-border-sm me-2 font-primary"
                                    role="status"
                                    aria-hidden="true"
                                  />
                                )}
                                {props.t("Enregistrer")}
                              </button>
                            </div>

                            <div className="inter-ligne"></div>
                            {isVerificationCreated && (
                              <Row className="my-2 mx-1">
                                <div className="alert alert-success alert-dismissible">
                                  <button
                                    type="button"
                                    className="btn-close font-primary"
                                    data-bs-dismiss="alert"
                                    aria-label="Close"
                                    style={{ fontSize: "14px" }}
                                  ></button>
                                  {props.t(
                                    "Email de vérification envoyé ! Veuillez "
                                  )}
                                  <b>
                                    {props.t(
                                      "consulter votre boîte de réception"
                                    )}
                                  </b>
                                  {props.t(
                                    " pour les instructions de vérification du compte."
                                  )}
                                </div>
                              </Row>
                            )}
                            <Row>
                              <Col
                                className="simple-text font-tertiary inner_section_title_2"
                                xl={6}
                              >
                                {props.t("E-mail")}
                                <h6
                                  className="mt-2 simple-text font-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {userInfos && userInfos.email}
                                </h6>
                              </Col>
                              <Col
                                xl={3}
                                style={{
                                  color:
                                    userInfos && userInfos.emailVerification
                                      ? "#367d61"
                                      : "#F10944"
                                }}
                                className="d-flex align-items-center simple-text font-primary"
                              >
                                {userInfos && userInfos.emailVerification ? (
                                  <>
                                    <i
                                      className="mdi mdi-check-circle me-2 "
                                      style={{ fontSize: "14px" }}
                                    />
                                    {props.t("Vérifié")}
                                  </>
                                ) : (
                                  <>
                                    <i
                                      className="mdi mdi-close-circle me-2"
                                      style={{ fontSize: "14px" }}
                                    />
                                    {props.t("Non Vérifié")}
                                  </>
                                )}
                              </Col>
                              {verificationCreationLoading ? (
                                <Col xl={3} className="action-div">
                                  <span
                                    className="spinner-border spinner-border-lg me-2 action-div"
                                    role="status"
                                    aria-hidden="true"
                                  ></span>
                                </Col>
                              ) : (
                                userInfos &&
                                !userInfos.emailVerification && (
                                  <Col
                                    xl={3}
                                    onClick={createAccountVerification}
                                    className="simple-text action-div font-primary"
                                    style={{
                                      color: "#5D5FEF",
                                      cursor: "pointer"
                                    }}
                                  >
                                    {props.t("Vérifier")}
                                  </Col>
                                )
                              )}
                            </Row>
                            <div className="inter-ligne"></div>
                            <Row>
                              <Col
                                className="simple-text font-tertiary inner_section_title_2"
                                xl={8}
                              >
                                <span
                                  className="font-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {props.t("Numéro de téléphone")} (
                                  {props.t("facultatif")})
                                </span>

                                <h6
                                  className="mt-2 simple-text font-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {userPrefs.phone
                                    ? userPrefs.phone
                                    : props.t("Aucun numéro de téléphone")}
                                </h6>
                              </Col>
                              <Col
                                xl={4}
                                className="simple-text action-div"
                                style={{ color: "#5D5FEF", cursor: "pointer" }}
                                onClick={tog_phone_modal}
                              >
                                <span
                                  className="font-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {userPrefs.phone
                                    ? props.t("Modifier")
                                    : props.t("Ajouter")}
                                </span>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      {/* </Row> */}

                      {/* <div className="inter-ligne"></div> */}
                      {/* Service de connexion connecté */}
                      {/* <Row>
                      <Col xl={2}>
                        <h6 className="mt-3 inner_section_title_1 font-primary">{props.t("Service de connexion connecté")}</h6>
                        <p className="simple-text font-primary">{props.t("profile_service_subtitle")}</p>
                      </Col>
                      <Col xl={10}>
                        <Card>
                          <CardBody>
                            <h6 className="inner_section_title_2 font-primary">{props.t("Services de connexion externe")}</h6>
                            <p className="mt-3 simple-text font-primary">{props.t("profile_service_subtitle")}</p>
                            <div className="inter-ligne"></div>
                            <div
                              className="font-primary"
                              style={{
                                color: "#5D5FEF",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }}>
                              <div className="">
                                <i className="mdi mdi-apple me-2" style={{ fontSize: "25px", color: "black" }} />
                              </div>
                              {props.t("Se connecter à")} Apple
                            </div>
                            <div className="inter-ligne"></div>
                            <div
                              className="font-primary"
                              style={{
                                color: "#5D5FEF",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }}>
                              <div className="">
                                <i className="mdi mdi-facebook me-2" style={{ fontSize: "25px" }} />
                              </div>
                              {props.t("Se connecter à")} Facebook
                            </div>
                            <div className="inter-ligne"></div>
                            <div
                              className="font-primary"
                              style={{
                                color: "#5D5FEF",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                              }}>
                              <div className="">
                                <i className="mdi mdi-google me-2" style={{ fontSize: "25px" }} />
                              </div>
                              {props.t("Se connecter à")} Google
                            </div>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row> */}
                      {/* <div className="inter-ligne"></div> */}

                      {/* <Row>
                    <Col xl={2}>
                      <h6
                        className="mt-3 inner_section_title_1"
                        style={{ fontSize: "14px" }}
                      >
                        {props.t("Langue préférée")}
                      </h6>
                      <p
                        className="simple-text font-primary"
                        style={{ fontSize: "14px" }}
                      >
                        {props.t("profile_langage_subtitle")}
                      </p>
                    </Col>
                    <Col xl={10}>
                      <Card>
                        <CardBody>
                          <Row>
                            <Col xl={12}>
                              <label
                                className="font-primary"
                                style={{ fontSize: "14px" }}
                              >
                                {props.t("Langue")}
                              </label>
                              <Dropdown
                                isOpen={btnmenu1}
                                toggle={() => setbtnmenu1(!btnmenu1)}
                                className=""
                              >
                                <DropdownToggle
                                  tag="button"
                                  className="btn btn-line d-flex align-items-center gap-2"
                                >
                                  <img
                                    src={
                                      selectLang
                                        ? languages[selectLang].flag
                                        : languages["fr"].flag
                                    }
                                    alt="iAssistant"
                                    className=""
                                    height="12"
                                  />
                                  {props.t(
                                    selectLang
                                      ? languages[selectLang].label
                                      : languages["fr"].label
                                  )}
                                  <i className="mdi mdi-chevron-down" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-lg-end">
                                  {map(Object.keys(languages), (key) => (
                                    <DropdownItem
                                      key={key}
                                      onClick={() => changeLanguageAction(key)}
                                      className={`notify-item ${selectLang === key ? "active" : "none"
                                        }`}
                                    >
                                      <img
                                        src={languages[key].flag}
                                        alt="iAssistant"
                                        className=""
                                        height="12"
                                      />

                                      <span
                                        className="align-middle"
                                        style={{ fontSize: "14px" }}
                                      >
                                        {props.t(languages[key].label)}
                                      </span>
                                    </DropdownItem>
                                  ))}
                                </DropdownMenu>
                              </Dropdown>
                            </Col>
                          </Row>
                        </CardBody>
                      </Card>
                    </Col>
                  </Row> */}
                      <div className="inter-ligne"></div>

                      <Row>
                        <Col xl={2}>
                          <h6
                            className="mt-3 inner_section_title_1 font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("Fuseau horaire")}
                          </h6>
                        </Col>
                        <Col xl={10}>
                          <Card>
                            <CardBody>
                              <h6 className="inner_section_title_2 font-primary">
                                {props.t("Fuseau horaire")}
                              </h6>
                              <Col md={7}>
                                <div className="form-floating mb-3">
                                  <select
                                    className="form-select"
                                    id="floatingSelectGrid"
                                    aria-label="Floating label select example"
                                    value={selectedTimezone}
                                    onChange={(e) =>
                                      setSelectedTimezone(e.target.value)
                                    }
                                  >
                                    {timezones.map((timezone) => (
                                      <option
                                        key={timezone}
                                        value={setUtc(timezone)}
                                      >
                                        {setUtc(timezone)}
                                      </option>
                                    ))}
                                  </select>
                                  <label htmlFor="floatingSelectGrid">
                                    <p className="font-primary">
                                      {props.t("Fuseau sélectionné")}:
                                      {selectedTimezone}
                                    </p>
                                  </label>
                                </div>
                              </Col>
                              {/* <p className="simple-text font-primary ">{props.t("profile_timezone_subtitle")}</p> */}
                              <div className="mt-3 mb-1 w-100 d-flex justify-content-end">
                                <button
                                  onClick={(e) => {
                                    handleTimeZoneUpdate();
                                  }}
                                  style={{
                                    backgroundColor: "#563bff",
                                    borderRadius: "20px"
                                  }}
                                  className="view-button simple-text font-primary"
                                >
                                  {updateTimezoneLoading && (
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    />
                                  )}
                                  {props.t("Enregistrer")}
                                </button>
                              </div>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <div className="inter-ligne"></div>

                      <Row>
                        <Col xl={2}>
                          <h6
                            className="mt-3 inner_section_title_1 font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("Mot de passe")}
                          </h6>
                        </Col>
                        <Col xl={10}>
                          <Card>
                            <CardBody>
                              <h6
                                className="inner_section_title_2 font-primary"
                                style={{ fontSize: "14px" }}
                              >
                                {userInfos &&
                                differenceInMilSec(userInfos) > 10000
                                  ? props.t("Dernière modification") +
                                    " : " +
                                    formatDate(
                                      props,
                                      userInfos.passwordUpdate,
                                      true
                                    )
                                  : props.t(
                                      "Vous n'avez jamais modifié votre mot de passe."
                                    )}
                              </h6>
                              <button
                                className="mt-4 view-button simple-text font-primary"
                                type="button"
                                onClick={tog_password_modal}
                                style={{
                                  backgroundColor: "#563bff",
                                  borderRadius: "20px"
                                }}
                              >
                                {props.t("Modifier votre mot de passe")}
                              </button>
                            </CardBody>
                          </Card>
                        </Col>
                      </Row>
                      <div className="inter-ligne"></div>

                      {/* Authentification en deux étapes */}
                      {/* <Row>
                      <Col xl={2}>
                        <h6 className="mt-3 inner_section_title_1 font-primary">{props.t("Authentification en deux étapes")}</h6>
                        <p className="simple-text font-primary">{props.t("profile_auth_subtitle")}</p>
                      </Col>
                      <Col xl={10}>
                        <Card>
                          <CardBody>
                            <h6 className="inner_section_title_2 font-primary">
                              {props.t("Méthodes d'authentification")} O {props.t("Désactivé")}
                            </h6>
                            <div className="simple-text font-primary">{props.t("profile_auth_subtitle_1")}</div>
                            <div className="inter-ligne"></div>

                            <Row>
                              <Col xl={1} className="d-flex align-items-center">
                                <i className="mdi mdi-security me-2" style={{ fontSize: "30px" }} />
                              </Col>
                              <Col xl={11} className="simple-text font-primary">
                                {props.t("profile_auth_subtitle_2")}
                              </Col>
                            </Row>
                            <h6 className="mt-4 font-primary">{props.t("COMMENT ÇA MARCHE?")}</h6>
                            <div className="simple-text font-primary">
                              {props.t("profile_auth_subtitle_3")} : <br />
                              1. {props.t("profile_auth_subtitle_3_1")} <br />
                              2. {props.t("profile_auth_subtitle_3_2")}
                            </div>
                            <button
                              style={{
                                backgroundColor: "#563bff",
                                borderRadius: "20px",
                              }}
                              className="mt-4 view-button simple-text font-primary"
                              type="button">
                              {props.t("Activer les deux étapes")}
                            </button>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                    <div className="inter-ligne"></div> */}

                      {/* <Row> */}
                      <Col xl={2}>
                        <h6
                          className="inner_section_title_1 font-primary"
                          style={{ fontSize: "14px" }}
                        >
                          {props.t("Appareils")}
                        </h6>
                      </Col>

                      <Col xl={10}>
                        <Card>
                          <CardBody>
                            <h6
                              className="inner_section_title_2 font-primary"
                              style={{ fontSize: "14px" }}
                            >
                              {props.t("Connecté(e)")}
                            </h6>
                            <p
                              className="simple-text font-primary"
                              style={{ fontSize: "14px" }}
                            >
                              {props.t("profile_auth_subtitle_4")}
                            </p>
                            <div className="inter-ligne"></div>

                            <Row>
                              <Col xl={8}>
                                <div className="d-flex">
                                  <div className="me-2">
                                    <i
                                      style={{ fontSize: "20px" }}
                                      className={`mdi ${
                                        user.deviceName
                                          ? "mdi-desktop-mac"
                                          : "mdi-cellphone"
                                      }`}
                                    />
                                  </div>
                                  <div
                                    className="me-3 simple-text font-primary"
                                    style={{
                                      color: "#3c6fc4",
                                      cursor: "pointer",
                                      fontSize: "14px"
                                    }}
                                  >
                                    {user.clientName} {props.t("sur")}{" "}
                                    {user.deviceBrand
                                      ? user.deviceBrand
                                      : user.deviceName}
                                  </div>
                                  <div
                                    style={{
                                      backgroundColor: "#b2e6f0",
                                      cursor: "pointer",
                                      borderRadius: "20px",
                                      padding: "2px 8px",
                                      color: "black",
                                      fontSize: "14px"
                                    }}
                                  >
                                    {props.t("Cet appareil")}
                                  </div>
                                </div>
                                <div
                                  className="mt-3 simple-text font-primary"
                                  style={{ fontSize: "14px" }}
                                >
                                  {formatDate(props, user.$createdAt, true)}{" "}
                                  <br />
                                  {user.countryName + ", " + user.countryCode}
                                </div>
                              </Col>
                              <Col xl={4} className="d-flex align-items-center">
                                <button
                                  type="button"
                                  className="view-button simple-text font-primary"
                                  style={{
                                    fontWeight: "600",
                                    backgroundColor: "#563bff",
                                    borderRadius: "20px"
                                  }}
                                >
                                  <Link
                                    to="/logout"
                                    className="text-white"
                                    style={{ fontSize: "14px" }}
                                  >
                                    <i className="ri-shut-down-line align-middle me-2 text-white" />
                                    {props.t("Logout")}
                                  </Link>
                                </button>
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>
                  </TabPane>

                  {/* <TabPane tabId="5">
                  <Ressources></Ressources>
                </TabPane> */}

                  {/* Utilisateurs & Aautorisations */}
                  <TabPane
                    tabId="6"
                    style={{
                      color: "black",
                      backgroundColor: "inherit",
                      paddingLeft: "8%",
                      paddingRight: "8%"
                    }}
                  >
                    {/* UPDATE EMPLOYEE MODAL */}
                    <Modal
                      isOpen={updateEmployeeModal}
                      toggle={tog_updateEmployeeModal}
                      centered
                      className="user-modal"
                      style={{ maxWidth: "40%" }}
                    >
                      <ModalBody>
                        <Button
                          className="close_button"
                          style={{
                            backgroundColor: "transparent",
                            border: "none",
                            padding: "0px",
                            float: "right"
                          }}
                          onClick={() => {
                            tog_updateEmployeeModal();
                          }}
                        >
                          {svgs.close_icon}
                        </Button>
                        <h1
                          className="modal_title font-primary"
                          style={{
                            marginTop: "4%",
                            marginBottom: "4%",
                            textTransform: "none",
                            fontSize: "18px"
                          }}
                        >
                          {props.t("Modifier un collaborateur")}
                        </h1>
                        <Row
                          className="mb-1 pb-4"
                          style={{
                            marginLeft: "4%",
                            marginRight: "4%",
                            borderBottom: "1px solid #CDCDCD"
                          }}
                        >
                          <Col xl={6}>
                            <Label for="first-name" className="font-primary">
                              {props.t("Prénom")}(s)
                            </Label>
                            <Input
                              id="first-name"
                              className="form-control font-primary simple-text"
                              value={employeeToUpdate?.first_name}
                              onChange={(e) => {
                                setEmployeeToUpdate({
                                  ...employeeToUpdate,
                                  first_name: e.target.value
                                });
                              }}
                            ></Input>
                          </Col>
                          <Col xl={6}>
                            <Label
                              for="last-name"
                              style={{ fontSize: "14px" }}
                              className="font-primary"
                            >
                              {props.t("Nom")}
                            </Label>
                            <Input
                              id="last-name"
                              className="form-control font-primary simple-text"
                              value={employeeToUpdate?.last_name}
                              onChange={(e) => {
                                setEmployeeToUpdate({
                                  ...employeeToUpdate,
                                  last_name: e.target.value
                                });
                              }}
                            ></Input>
                          </Col>
                          <p className="font-primary simple-text mt-3 font-primary">
                            {props.t("add_user_msg")}
                          </p>
                          <Col xl={12}>
                            <Label
                              for=""
                              style={{ fontSize: "14px" }}
                              className="font-primary"
                            >
                              {props.t("Adresse e-mail")}
                            </Label>
                            <Input
                              className="form-control font-primary simple-text"
                              value={employeeToUpdate?.email}
                              onChange={(e) => {
                                setEmployeeToUpdate({
                                  ...employeeToUpdate,
                                  email: e.target.value
                                });
                              }}
                            ></Input>
                          </Col>
                        </Row>
                        <Row
                          className="py-4"
                          style={{ marginLeft: "4%", marginRight: "4%" }}
                        >
                          <h6
                            className="font-primary font-tertiary font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("Autorisations de boutique")}
                          </h6>
                          <p
                            className="font-primary simple-text mb-0 font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("add_user_subtitle_2")}
                          </p>
                          {/* <div className="row g-4 mb-3">
                            <div className="">
                              <div className="search-box ms-2">
                                <input type="text" className="form-control font-primary simple-text search" placeholder={props.t("Search") + "..."} />
                                <i className="ri-search-line search-icon mt-4"></i>
                              </div>
                            </div>
                          </div> */}
                          <Row className="mt-4 mb-4">
                            <Col xl={12}>
                              <label
                                className="font-tertiary"
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                  fontSize: "14px"
                                }}
                              >
                                <input
                                  className="me-2"
                                  type="checkbox"
                                  checked={authorizations[0].status}
                                  defaultChecked={authorizations[0].status}
                                  onClick={(e) => {
                                    let updatedAuthorizations = [
                                      ...authorizations
                                    ];
                                    updatedAuthorizations[0].status =
                                      !updatedAuthorizations[0].status;
                                    handleParentCheckboxChange(
                                      updatedAuthorizations,
                                      authorizations[0].id,
                                      updatedAuthorizations[0].status
                                    );
                                  }}
                                />
                                {props.t(authorizations[0].text)}
                              </label>
                            </Col>
                          </Row>
                          <div
                            className="accordion accordion-boutique"
                            id="accordionFlushExample"
                          >
                            {authorizations.map(
                              (authorization, idx) =>
                                authorization.parents.length === 1 && (
                                  <div key={idx} className="accordion-item">
                                    <h2
                                      className="accordion-header d-flex"
                                      id={"flush-heading" + authorization.value}
                                    >
                                      <input
                                        className="me-2"
                                        type="checkbox"
                                        defaultChecked={
                                          authorizations[idx].status
                                        }
                                        checked={authorizations[idx].status}
                                        onClick={(e) => {
                                          let updatedAuthorizations = [
                                            ...authorizations
                                          ];
                                          updatedAuthorizations[idx].status =
                                            !updatedAuthorizations[idx].status;
                                          handleParentCheckboxChange(
                                            updatedAuthorizations,
                                            authorization.id,
                                            updatedAuthorizations[idx].status,
                                            authorization.id
                                          );
                                        }}
                                      />
                                      <button
                                        className="accordion-button collapsed accordion-new-button mt-2 font-primary"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={
                                          "#flush-collapse" +
                                          authorization.value
                                        }
                                        aria-expanded="false"
                                        aria-controls={
                                          "flush-collapse" + authorization.value
                                        }
                                      >
                                        <label
                                          className="font-tertiary font-primary"
                                          style={{ fontSize: "14px" }}
                                        >
                                          {props.t(authorization.text)}
                                        </label>
                                      </button>
                                    </h2>
                                    <div
                                      id={
                                        "flush-collapse" + authorization.value
                                      }
                                      className="accordion-collapse collapse"
                                      aria-labelledby={
                                        "flush-heading" + authorization.value
                                      }
                                      data-bs-parent="#accordionFlushExample"
                                    >
                                      <div className="accordion-body">
                                        <div style={{ marginLeft: "30px" }}>
                                          <ul className="checkbox-list font-primary">
                                            {authorizations.map(
                                              (
                                                authorizationChild,
                                                childIndex
                                              ) =>
                                                authorizationChild
                                                  .parents[1] ===
                                                  authorization.id && (
                                                  <li key={childIndex}>
                                                    <label className="font-primary simple-text">
                                                      <input
                                                        className="me-2"
                                                        type="checkbox"
                                                        checked={
                                                          authorizations[
                                                            childIndex
                                                          ].status
                                                        }
                                                        onClick={(e) => {
                                                          let updatedAuthorizations =
                                                            [...authorizations];
                                                          updatedAuthorizations[
                                                            childIndex
                                                          ].status =
                                                            !updatedAuthorizations[
                                                              childIndex
                                                            ].status;
                                                          handleChildCheckboxChange(
                                                            updatedAuthorizations,
                                                            authorizationChild.id,
                                                            authorizationChild
                                                              .parents[1],
                                                            updatedAuthorizations[
                                                              childIndex
                                                            ].status
                                                          );
                                                        }}
                                                      />
                                                      {props.t(
                                                        authorizationChild.text
                                                      )}
                                                    </label>
                                                  </li>
                                                )
                                            )}
                                          </ul>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                )
                            )}
                          </div>
                        </Row>
                        <Row
                          className="py-4"
                          style={{ marginLeft: "4%", marginRight: "4%" }}
                        >
                          <h6
                            className="font-tertiary font-size-16 font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("Notifications")}
                          </h6>
                          <p
                            className="font-primary simple-text"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t("add_user_subtitle_3")}
                          </p>
                          <Row className="mt-4 mb-4">
                            <Col xl={12}>
                              <label
                                className="font-primary"
                                style={{
                                  color: "black",
                                  cursor: "pointer",
                                  fontSize: "14px"
                                }}
                              >
                                <input
                                  className="me-2"
                                  type="checkbox"
                                  checked={allCkecked}
                                  defaultChecked={allCkecked}
                                  onClick={(e) => {
                                    setAllChecked(!allCkecked);
                                    handleNotifAllCheck(!allCkecked);
                                  }}
                                />
                                {props.t(
                                  "Sélectionner toutes les notifications"
                                )}
                              </label>
                            </Col>
                          </Row>
                          <div
                            className="accordion accordion-boutique"
                            id="accordionFlushExample"
                          >
                            {notificationData.map((data, idx) => (
                              <div key={idx} className="accordion-item">
                                <h2
                                  className="accordion-header d-flex font-primary"
                                  id={"flush-heading" + idx}
                                >
                                  <input
                                    className="me-2"
                                    type="checkbox"
                                    checked={notifications[data.key]}
                                    onClick={(e) => {
                                      let updatedNotifications = {
                                        ...notifications
                                      };
                                      updatedNotifications[data.key] =
                                        !updatedNotifications[data.key];
                                      setNotifications(updatedNotifications);
                                      handleNotifCheckChange(
                                        data.key,
                                        updatedNotifications[data.key]
                                      );
                                    }}
                                  />
                                  <button
                                    className="accordion-button collapsed accordion-new-button mt-2 font-primary"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={"#flush-collapse" + idx}
                                    aria-expanded="false"
                                    aria-controls={"flush-collapse" + idx}
                                  >
                                    <label
                                      className="font-tertiary font-primary"
                                      style={{ fontSize: "14px" }}
                                    >
                                      {props.t(data.title)}
                                    </label>
                                  </button>
                                </h2>
                                <div
                                  id={"flush-collapse" + idx}
                                  className="accordion-collapse collapse"
                                  aria-labelledby={"flush-heading" + idx}
                                  data-bs-parent="#accordionFlushExample"
                                >
                                  <div className="accordion-body">
                                    <div style={{ marginLeft: "10px" }}>
                                      <ul className="checkbox-list">
                                        <li>
                                          <p
                                            className="font-primary simple-text"
                                            style={{ fontSize: "14px" }}
                                          >
                                            {props.t(data.description)}
                                          </p>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </Row>
                        <Row
                          className="my-4 justify-content-center gap-3"
                          style={{ marginLeft: "4%", marginRight: "4%" }}
                        >
                          <Button
                            className="col-3 font-primary simple-text d-flex justify-content-center align-items-center"
                            style={{
                              color: "#fff",
                              fontWeight: "600",
                              border: "none",
                              background: "#563bff",
                              boxShadow:
                                "0px 16.21px 37.81px 0px rgba(255, 112, 73, 0.20)",
                              borderRadius: "10px",
                              fontSize: "14px"
                            }}
                            onClick={handleModalEmployeeUpdate}
                          >
                            {loading ? (
                              <span
                                className="spinner-border spinner-border-sm me-2 font-primary"
                                role="status"
                                aria-hidden="true"
                              />
                            ) : (
                              props.t("Enregistrer")
                            )}
                          </Button>
                          <Button
                            className="col-3 font-primary simple-text "
                            style={{
                              borderRadius: "10px",
                              fontWeight: "600",
                              fontSize: "14px"
                            }}
                            onClick={tog_updateEmployeeModal}
                          >
                            {props.t("Annuler")}
                          </Button>
                        </Row>
                      </ModalBody>
                    </Modal>
                    {
                      //company_employees_data ? (
                      <div className="users-tabpane col-xxl-8 col-xl-8 ms-auto me-auto">
                        <Row className="align-items-center justify-content-between flex-row mb-3">
                          <div className="col-md-9">
                            <h3
                              className="section-title font-primary"
                              style={{ fontSize: "18px" }}
                            >
                              {props.t(
                                "Contrôlez les accès et les rôles au sein de votre compte."
                              )}
                            </h3>
                          </div>
                          <div className="col-md-3">
                            {userInfos && userInfos.prefs["owner"] && (
                              <div>
                                <Tooltip
                                  placement="left"
                                  // isOpen={tooltip === "tooltips_add_member_button" && employeesList.length >= maxTeamMember}
                                  isOpen={false}
                                  target={"tooltips_add_member_button"}
                                  toggle={() => {
                                    if (
                                      tooltip === "tooltips_add_member_button"
                                    ) {
                                      setTooltip(false);
                                    } else {
                                      setTooltip("tooltips_add_member_button");
                                    }
                                  }}
                                >
                                  {props.t(
                                    "Upgradez votre plan pour pouvoir ajouter plus de membres"
                                  )}
                                </Tooltip>
                                <button
                                  type="button"
                                  id={"tooltips_add_member_button"}
                                  className="simple-text view-button font-primary"
                                  //   disabled={employeesList.length >= maxTeamMember}
                                  style={{
                                    backgroundColor: "#563bff",
                                    //    cursor: employeesList.length >= maxTeamMember ? "not-allowed" : "pointer",
                                    cursor: "pointer"
                                  }}
                                  onClick={() => tog_list()}
                                >
                                  <i className="ri-add-line align-bottom me-1"></i>
                                  {props.t("Ajouter un collaborateur")}
                                </button>
                              </div>
                            )}
                          </div>
                        </Row>

                        <Row className="mb-4">
                          <Col>
                            <h5
                              className="simple-text font-primary"
                              style={{
                                color: "#666969",
                                fontStyle: "normal",
                                fontWeight: "400",
                                fontSize: "14px"
                              }}
                            >
                              {props.t("users_subtitle")}
                            </h5>
                          </Col>
                        </Row>

                        {/* {ownerInfos && ownerInfos.last_name && (
                          <Card
                            className="user-card font-primary"
                            style={{
                              borderLeft: "5px solid #563BFF",
                              marginBottom: "15px",
                              borderRadius: "10px",
                              boxShadow: "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                              paddingTop: "6px",
                              paddingRight: "29px",
                              paddingBottom: "10px",
                              paddingLeft: "16px"
                            }}>
                            <CardBody className="p-0">
                              <Row className="">
                                <Col className="d-flex align-items-center col-md-auto font-primary">
                                <input
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "6px",
                                    border: "1.5px solid #D9D9D9",
                                  }}
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  defaultValue=""
                                  // value={`option${index + 1}`}
                                />
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    fontSize: "250%",
                                    backgroundColor: "grey",
                                    color: "white",
                                    padding: "10px  20px",
                                    borderRadius: "8px",
                                    textAlign: "center",
                                    width: "86px",
                                    height: "86px",
                                  }}>
                                  {ownerInfos.last_name
                                    .split(" ")
                                    .map((part) => part.charAt(0).toUpperCase())
                                    .join("")}
                                </div>
                              </Col>

                                <Col md={4} className="">
                                  <div
                                    className="user-name font-primary"
                                    style={{
                                      width: "fit-content",
                                      color: "#1E222C",

                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: "500",
                                      lineHeight: "38.454px",
                                      position: "relative"
                                    }}>
                                    {ownerInfos.first_name} {ownerInfos.last_name}
                                  </div>
                                </Col>
                                <Col md={2} className="d-flex align-items-center">
                                  <div
                                    style={{
                                      color: "#563bff",
                                      fontStyle: "normal",
                                      fontWeight: "500"
                                    }}
                                    className="simple-text font-primary">
                                    {props.t("Propriétaire")}
                                  </div>
                                </Col>
                              </Row>
                            </CardBody>
                          </Card>
                        )} */}

                        {client_data &&
                          client_data.collaborators &&
                          client_data.collaborators.map((employee, index) => (
                            <Card
                              className="user-card font-primary"
                              style={{
                                borderLeft: "5px solid #563BFF",
                                marginBottom: "15px",
                                borderRadius: "10px",
                                boxShadow:
                                  "0px 6px 24px 1px rgba(53, 22, 252, 0.1)",
                                paddingTop: "6px",
                                paddingRight: "29px",
                                paddingBottom: "10px",
                                paddingLeft: "16px"
                              }}
                            >
                              <CardBody className="p-0">
                                <Row>
                                  {/*<Col className="d-flex flex-wrap gap-3 align-items-center col-md-auto font-primary">
                                 <input
                                  style={{
                                    width: "20px",
                                    height: "20px",
                                    borderRadius: "6px",
                                    border: "1.5px solid #D9D9D9",
                                  }}
                                  className="form-check-input mt-0"
                                  type="checkbox"
                                  value={`option${index + 1}`}
                                /> 
                                <div
                                  className="d-flex align-items-center justify-content-center"
                                  style={{
                                    fontSize: "150%",
                                    backgroundColor: "grey",
                                    color: "white",
                                    padding: "10px  20px",
                                    borderRadius: "8px",
                                    textAlign: "center",
                                    width: "46px",
                                    height: "46px",
                                  }}>
                                  {employee.last_name
                                    .split(" ")
                                    .map((part) => part.charAt(0).toUpperCase())
                                    .join("")}
                                  {employee.first_name
                                    .split(" ")
                                    .map((part) => part.charAt(0).toUpperCase())
                                    .join("")}
                                </div>
                              </Col>*/}

                                  <Col
                                    md={4}
                                    className="d-flex align-items-center"
                                  >
                                    <div className="d-flex align-items-end gap-2">
                                      <div className="d-flex align-items-baseline gap-2">
                                        <div
                                          className="agent-name font-primary"
                                          style={{
                                            width: "fit-content",
                                            color: "#1E222C",

                                            fontSize: "14px",
                                            fontStyle: "normal",
                                            fontWeight: "500",
                                            lineHeight: "38.454px",
                                            position: "relative"
                                          }}
                                        >
                                          {employee.first_name}{" "}
                                          {employee.last_name}
                                        </div>
                                      </div>
                                    </div>
                                  </Col>
                                  <Col
                                    md={2}
                                    className="d-flex align-items-center"
                                  >
                                    <div
                                      style={{
                                        color: "#FF7049",
                                        fontStyle: "normal",
                                        fontWeight: "500"
                                      }}
                                      className="simple-text font-primary"
                                    >
                                      {props.t("Employé")}
                                    </div>
                                  </Col>
                                  {/* <Col className="d-flex align-items-center">
                                  <span
                                    className="gap-2 font-primary"
                                    style={{
                                      color: "#1E8E3E",
                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: "300",
                                      height: "fit-content"
                                    }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
                                      <path
                                        d="M4 8C6.20914 8 8 6.20914 8 4C8 1.79086 6.20914 0 4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8Z"
                                        fill={"#1E8E3E"}
                                      />
                                    </svg>
                                    
                                  </span>
                                </Col> */}
                                  <Col className="d-flex align-items-center">
                                    <div
                                      className="col-auto user-info font-primary"
                                      style={{
                                        color: "#272B35",

                                        fontSize: "14px",
                                        fontStyle: "normal",
                                        fontWeight: "400",
                                        lineHeight: "18px"
                                      }}
                                    >
                                      {/* <i className="dripicons-mail me-2 align-middle font-primary"></i> */}
                                      {employee.email}
                                    </div>
                                  </Col>
                                  {/* <Col className="d-flex align-items-center">
                                  <div
                                    className="col-auto user-info font-primary"
                                    style={{
                                      color: "#272B35",

                                      fontSize: "14px",
                                      fontStyle: "normal",
                                      fontWeight: "400",
                                      lineHeight: "18px"
                                    }}>
                                    <i className="dripicons-phone me-2 align-middle font-primary"></i>
                                    {employee.phone ?? "---"}
                                  </div>
                                </Col> */}

                                  <Col className="d-flex justify-content-end col-md-full">
                                    {userInfos && userInfos.prefs["owner"] && (
                                      <div className="d-flex">
                                        {employeeEditActions[employee.id] &&
                                        employeeEditActions[employee.id]
                                          .loading ? (
                                          <span
                                            className="spinner-border spinner-border-sm me-2"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                        ) : (
                                          <Dropdown
                                            isOpen={
                                              employeeEditActions[
                                                employee.id
                                              ] &&
                                              employeeEditActions[employee.id]
                                                .state
                                            }
                                            toggle={() => {
                                              setEmployeesEditActions(
                                                (prevState) => ({
                                                  ...prevState,
                                                  [employee.id]: prevState[
                                                    employee.id
                                                  ]
                                                    ? {
                                                        state:
                                                          !prevState[
                                                            employee.id
                                                          ].state,
                                                        loading:
                                                          prevState[employee.id]
                                                            .loading
                                                      }
                                                    : {
                                                        state: true,
                                                        loading: false
                                                      }
                                                })
                                              );
                                            }}
                                            style={{
                                              display: "flex"
                                            }}
                                          >
                                            <DropdownToggle
                                              tag="button"
                                              className={`btn email-menu-dropdown email-menu-dropdown-active                                      `}
                                              style={{
                                                border: "none",
                                                padding: "0",
                                                marginRight: "10px"
                                              }}
                                            >
                                              <svg
                                                width="27"
                                                height="7"
                                                viewBox="0 0 27 7"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <g id="Group 1000002886">
                                                  <circle
                                                    id="Ellipse 1029"
                                                    cx="3"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                  <circle
                                                    id="Ellipse 1031"
                                                    cx="13.4277"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                  <circle
                                                    id="Ellipse 1030"
                                                    cx="23.5723"
                                                    cy="3.24402"
                                                    r="3"
                                                    fill="#563BFF"
                                                  />
                                                </g>
                                              </svg>
                                            </DropdownToggle>
                                            <DropdownMenu>
                                              <DropdownItem
                                                onClick={() => {
                                                  onEmployeeToUpdateChanged(
                                                    employee
                                                  );
                                                  decodeAuthozations(
                                                    [
                                                      ...employee.autorizations,
                                                      ...employee.contact_reasons
                                                    ],
                                                    employee
                                                  );
                                                  tog_updateEmployeeModal();
                                                }}
                                              >
                                                {props.t("Modifier")}
                                              </DropdownItem>
                                              <DropdownItem
                                                onClick={() => {
                                                  setEmployeesEditActions(
                                                    (prevState) => ({
                                                      ...prevState,
                                                      [employee.id]: {
                                                        state: false,
                                                        loading: true
                                                      }
                                                    })
                                                  );
                                                  deleteUserRole(
                                                    employee.id,
                                                    employee.email
                                                  );
                                                }}
                                              >
                                                {props.t("Supprimer")}
                                              </DropdownItem>
                                            </DropdownMenu>
                                          </Dropdown>
                                        )}
                                      </div>
                                    )}
                                  </Col>
                                </Row>
                                {/* <div className="mt-3 d-flex">
                                          <div className="me-3 mt-1">
                                            <div style={{ backgroundColor: 'grey', color: 'white', padding: '8px', borderRadius: '8px', width: '35px', textAlign: 'center' }}>
                                              AA
                                            </div>
                                          </div>
                                          <div className="">
                                            <div style={{ color: 'blue' }}>Alex Anihouvi</div>
                                            <div>Dernière connexion : dimanche 24 septembre 2023 18:17 UTC+1</div>
                                          </div>
                                          <div style={{marginLeft:'20%'}}>
                                            Autorisations limitées
                                          </div>
                                        </div> */}
                              </CardBody>
                            </Card>
                          ))}
                      </div>
                      // ) : (
                      //   <div className="font-primary">{props.t("Échec de chargement")}</div>
                      // )
                    }
                  </TabPane>

                  <TabPane tabId="7">
                    {userInfos && client_data && (
                      <BillingPage
                        userInfos={userInfos}
                        client_data={client_data}
                      />
                    )}
                  </TabPane>

                  <TabPane tabId="8">
                    <Notifications />
                  </TabPane>

                  {userInfos && userInfos.prefs["owner"] && (
                    <TabPane tabId="9">
                      <Logs userInfo={userInfos} />
                    </TabPane>
                  )}
                </TabContent>
              </Col>
            </Row>
          </Col>
        </div>
      </div>
      {/* Add emplpoyee Modal */}
      <Modal
        isOpen={modal_list}
        toggle={tog_list}
        centered
        className="user-modal"
      >
        <ModalHeader
          className="bg-light p-3 font-primary"
          id="exampleModalLabel"
          toggle={tog_list}
        >
          {props.t("AJOUTER UN COLLABORATEUR")}
        </ModalHeader>
        <form className="tablelist-form">
          <ModalBody>
            <h6
              className="font-tertiary font-size-16 font-primary"
              style={{ fontSize: "14px" }}
            >
              {props.t("Employés")}
            </h6>
            <p className="font-primary simple-text">
              {props.t("add_user_subtitle")}
              <Link> {props.t("add_user_subtitle_link")}</Link>
            </p>
            <Card>
              <CardBody>
                <Row>
                  <Col md={6}>
                    <div>
                      <label
                        className="font-primary font-primary"
                        style={{ fontSize: "14px" }}
                      >
                        {props.t("Prénom")}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder=" "
                        required
                        value={modalInfo.first_name}
                        onChange={(e) =>
                          setModalInfo({
                            ...modalInfo,
                            first_name: e.target.value
                          })
                        }
                      />
                    </div>
                  </Col>
                  <Col md={6}>
                    <div>
                      <label
                        className="font-primary font-primary"
                        style={{ fontSize: "14px" }}
                      >
                        {props.t("Nom")}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder=" "
                        required
                        value={modalInfo.last_name}
                        onChange={(e) =>
                          setModalInfo({
                            ...modalInfo,
                            last_name: e.target.value
                          })
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <p className="mt-4 font-primary simple-text">
                  {props.t("add_user_msg")}
                </p>
                <Row>
                  <Col md={12}>
                    <div>
                      <label
                        className="font-primary font-primary"
                        style={{ fontSize: "14px" }}
                      >
                        {props.t("Adresse e-mail")}
                      </label>
                      <input
                        className="form-control"
                        type="text"
                        placeholder=" "
                        required
                        value={modalInfo.email}
                        onChange={(e) =>
                          setModalInfo({ ...modalInfo, email: e.target.value })
                        }
                      />
                    </div>
                  </Col>
                </Row>
              </CardBody>
            </Card>
            <Card style={{ boxShadow: "none" }}>
              <CardBody>
                <h6
                  className="font-tertiary font-size-16 font-primary"
                  style={{ fontSize: "14px" }}
                >
                  {props.t("Autorisations de boutique")}
                </h6>
                <p className="font-primary simple-text font-primary">
                  {props.t("add_user_subtitle_2")}
                </p>
                {/* <Row className="g-4 mb-3">
                  <div className="">
                    <div className="search-box ms-2">
                      <input type="text" className="form-control search" placeholder={props.t("Search") + "..."} style={{ borderRadius: "5px" }} />
                      <i className="ri-search-line search-icon mt-4"></i>
                    </div>
                  </div>
                </Row> */}
                <Row className="mt-4 mb-4">
                  <Col xl={12}>
                    <label
                      className="font-tertiary font-primary"
                      style={{ color: "black", cursor: "pointer" }}
                    >
                      <input
                        className="me-2"
                        type="checkbox"
                        checked={authorizations[0].status}
                        defaultChecked={authorizations[0].status}
                        onClick={(e) => {
                          let updatedAuthorizations = [...authorizations];
                          updatedAuthorizations[0].status =
                            !updatedAuthorizations[0].status;
                          handleParentCheckboxChange(
                            updatedAuthorizations,
                            authorizations[0].id,
                            updatedAuthorizations[0].status
                          );
                        }}
                      />
                      {props.t(authorizations[0].text)}
                    </label>
                  </Col>
                </Row>
                <div
                  className="accordion accordion-boutique"
                  id="accordionFlushExample"
                >
                  {authorizations.map(
                    (authorization, idx) =>
                      authorization.parents.length === 1 && (
                        <div key={idx} className="accordion-item">
                          <h2
                            className="accordion-header d-flex"
                            id={"flush-heading" + authorization.value}
                          >
                            <input
                              className="me-2"
                              type="checkbox"
                              defaultChecked={authorizations[idx].status}
                              checked={authorizations[idx].status}
                              onClick={(e) => {
                                let updatedAuthorizations = [...authorizations];
                                updatedAuthorizations[idx].status =
                                  !updatedAuthorizations[idx].status;
                                handleParentCheckboxChange(
                                  updatedAuthorizations,
                                  authorization.id,
                                  updatedAuthorizations[idx].status,
                                  authorization.id
                                );
                              }}
                            />
                            <button
                              className="accordion-button collapsed accordion-new-button mt-2 font-primary"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={
                                "#flush-collapse" + authorization.value
                              }
                              aria-expanded="false"
                              aria-controls={
                                "flush-collapse" + authorization.value
                              }
                            >
                              <label
                                className="font-tertiary font-primary"
                                style={{ fontSize: "14px" }}
                              >
                                {props.t(authorization.text)}
                              </label>
                            </button>
                          </h2>
                          <div
                            id={"flush-collapse" + authorization.value}
                            className="accordion-collapse collapse"
                            aria-labelledby={
                              "flush-heading" + authorization.value
                            }
                            data-bs-parent="#accordionFlushExample"
                          >
                            <div className="accordion-body">
                              <div style={{ marginLeft: "30px" }}>
                                <ul className="checkbox-list font-primary">
                                  {authorizations.map(
                                    (authorizationChild, childIndex) =>
                                      authorizationChild.parents[1] ===
                                        authorization.id && (
                                        <li key={childIndex}>
                                          <label className="font-primary simple-text">
                                            <input
                                              className="me-2"
                                              type="checkbox"
                                              checked={
                                                authorizations[childIndex]
                                                  .status
                                              }
                                              onClick={(e) => {
                                                let updatedAuthorizations = [
                                                  ...authorizations
                                                ];
                                                updatedAuthorizations[
                                                  childIndex
                                                ].status =
                                                  !updatedAuthorizations[
                                                    childIndex
                                                  ].status;
                                                handleChildCheckboxChange(
                                                  updatedAuthorizations,
                                                  authorizationChild.id,
                                                  authorizationChild.parents[1],
                                                  updatedAuthorizations[
                                                    childIndex
                                                  ].status
                                                );
                                              }}
                                            />
                                            {props.t(authorizationChild.text)}
                                          </label>
                                        </li>
                                      )
                                  )}
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      )
                  )}
                </div>
              </CardBody>
            </Card>
            <Card style={{ boxShadow: "none" }}>
              <CardBody>
                <h6
                  className="font-size-16 font-primary"
                  style={{ fontSize: "14px" }}
                >
                  {props.t("Notifications")}
                </h6>
                <p className="font-primary simple-text">
                  {props.t("add_user_subtitle_3")}
                </p>
                <Row className="mt-4 mb-4">
                  <Col xl={12}>
                    <label
                      className="font-primary"
                      style={{ color: "black", cursor: "pointer" }}
                    >
                      <input
                        className="me-2"
                        type="checkbox"
                        checked={allCkecked}
                        defaultChecked={allCkecked}
                        onClick={(e) => {
                          setAllChecked(!allCkecked);
                          handleNotifAllCheck(!allCkecked);
                        }}
                      />
                      {props.t("Sélectionner toutes les notifications")}
                    </label>
                  </Col>
                </Row>
                <div
                  className="accordion accordion-boutique"
                  id="accordionFlushExample"
                >
                  {notificationData.map((data, idx) => (
                    <div key={idx} className="accordion-item">
                      <h2
                        className="accordion-header d-flex font-primary"
                        id={"flush-heading" + idx}
                      >
                        <input
                          className="me-2"
                          type="checkbox"
                          checked={notifications[data.key]}
                          onClick={(e) => {
                            let updatedNotifications = {
                              ...notifications
                            };
                            updatedNotifications[data.key] =
                              !updatedNotifications[data.key];
                            setNotifications(updatedNotifications);
                            handleNotifCheckChange(
                              data.key,
                              updatedNotifications[data.key]
                            );
                          }}
                        />
                        <button
                          className="accordion-button collapsed accordion-new-button mt-2 font-primary"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={"#flush-collapse" + idx}
                          aria-expanded="false"
                          aria-controls={"flush-collapse" + idx}
                        >
                          <label
                            className="font-tertiary font-primary"
                            style={{ fontSize: "14px" }}
                          >
                            {props.t(data.title)}
                          </label>
                        </button>
                      </h2>
                      <div
                        id={"flush-collapse" + idx}
                        className="accordion-collapse collapse"
                        aria-labelledby={"flush-heading" + idx}
                        data-bs-parent="#accordionFlushExample"
                      >
                        <div className="accordion-body">
                          <div style={{ marginLeft: "10px" }}>
                            <ul className="checkbox-list">
                              <li>
                                <p
                                  className="font-primary simple-text"
                                  style={{ fontSize: "14px" }}
                                >
                                  {props.t(data.description)}
                                </p>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <div
              className="hstack gap-2 justify-content-end"
              style={{ width: "100%" }}
            >
              <button
                type="button"
                className="view-button"
                style={{ color: "black", width: "100%" }}
                onClick={tog_list}
              >
                {props.t("Fermer")}
              </button>
              <button
                type="button"
                style={{ backgroundColor: "#563bff", width: "100%" }}
                className="view-button center font-primary"
                id="edit-btn"
                onClick={handleEmployeeAdded}
              >
                {loading ? (
                  <span
                    className="spinner-border spinner-border-sm me-2 font-primary"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  props.t("Enregistrer")
                )}
              </button>
            </div>
          </ModalFooter>
          <div
            className="row"
            style={{ marginLeft: "8px", marginRight: "8px" }}
          >
            <div classname="col-md-12">
              {addCollaboratorError ? (
                <Alert color="danger" className="text-center">
                  {props.t(addCollaboratorError)}
                </Alert>
              ) : null}
            </div>
          </div>
        </form>
      </Modal>
      {/* Add agent Modal */}
      {/* <Modal isOpen={addAgentModal} toggle={togAddAgentModal} centered>
        <ModalHeader className="bg-light p-3" id="exampleModalLabel" toggle={togAddAgentModal}>
          {props.t("Ajouter un agent")}
        </ModalHeader>
        <form className="tablelist-form" onSubmit={(e) => e.preventDefault()}>
          <ModalBody>
            <h6 className="font-tertiary font-size-16 font-primary" style={{ fontSize: "14px" }}>
              {props.t("Agent")}
            </h6>
            <Card style={{ boxShadow: "none" }}>
              <CardBody>
                <Row className="mb-4">
                  <Col md={12}>
                    <div>
                      <label className="font-primary font-primary" style={{ fontSize: "14px" }}>
                        {props.t("Nom de l'agent")}
                      </label>
                      <input
                        className="form-control font-primary simple-text"
                        type="text"
                        placeholder=" "
                        required
                        value={agentModalInfo.agent_name}
                        onChange={(e) =>
                          setAgentModalInfo({
                            ...agentModalInfo,
                            agent_name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="my-4">
                  <Col md={12}>
                    <div>
                      <div>
                        <label className="font-primary" style={{ fontSize: "14px" }}>
                          {`${props.t("Langue de l'agent")} (${agentModalInfo.agent_language.length}/${numberOfLanguages})`}
                        </label>
                        {numberOfLanguages === agentModalInfo.agent_language.length && (
                          <div
                            onClick={onShowCalculator}
                            className="font-size-12"
                            style={{ float: "right", color: "rgb(86, 59, 255)", cursor: "pointer" }}>
                            {props.t("Upgrade to get more")}
                          </div>
                        )}
                      </div>
                      <div className="mb-3 templating-select select2-container font-primary">
                        <Select
                          // isOptionDisabled={(option, selectValue) => {
                          //   return true;
                          // }}
                          // isDisabled={numberOfLanguages === agentModalInfo.agent_language.length}
                          closeMenuOnSelect={numberOfLanguages === agentModalInfo.agent_language.length}
                          styles={{
                            option: (provided, state) => ({
                              ...provided,
                              cursor: numberOfLanguages === agentModalInfo.agent_language.length ? "not-allowed" : "pointer",
                              backgroundColor: "transparent",
                            }),
                          }}
                          style={{ zIndex: "9999" }}
                          value={agentModalInfo.agent_language.map((lang) => {
                            return {
                              label: props.t(lang.name),
                              value: lang.code,
                            };
                          })}
                          isMulti={true}
                          onChange={(e) => {
                            if (numberOfLanguages > agentModalInfo.agent_language.length || e.length <= numberOfLanguages) {
                              setAgentModalInfo({
                                ...agentModalInfo,
                                agent_language: e.map((lang) => {
                                  return { name: lang.label, code: lang.value };
                                }),
                              });
                            }
                          }}
                          placeholder={props.t("Select") + "..."}
                          options={optionGroup2.map((lang) => {
                            return {
                              label: props.t(lang.label),
                              value: lang.value,
                            };
                          })}
                          classNamePrefix="select2-selection"
                          components={animatedComponents}
                        />
                        {agentModalInfo.agent_language.length === 0 && (
                          <span className="font-size-12" style={{ color: "red" }}>
                            {props.t("Vous devez sélectionner au moins une langue pour Synibox.")}
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Col md={12} className="mb-4">
                  <label className="font-primary" style={{ fontSize: "14px" }}>
                    {props.t("Horaires d'activité de l'agent")}
                  </label>
                  <div className="form-floating mb-3">
                    <select
                      className="form-select form-control font-primary"
                      id="floatingSelectGrid"
                      aria-label="Floating label select example"
                      value={agentSelectedTimezone}
                      onChange={(e) => setAgentTimezone(setUtc(e.target.value))}>
                      <option value={agentSelectedTimezone}>{agentSelectedTimezone}</option>
                      {timezones.map((timezone, index) => (
                        <option className="font-primary" key={index} value={timezone}>
                          {setUtc(timezone)}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="floatingSelectGrid">
                      <p className="font-primary">
                        {props.t("Fuseau sélectionné")}: {agentSelectedTimezone}
                      </p>
                    </label>
                  </div>
                </Col>
                <Row>
                  <Col md={12}>
                    {daysOfWeek.map((day, index) => (
                      <Row key={day} className="mb-3">
                        <Col className="col-4">
                          <div style={{ marginTop: "13px" }} key={index} className="form-check mb-3 font-primary">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              defaultValue=""
                              id={`inlineCheck-${day}`}
                              onClick={() => handleTimeChange(day, "checked", timesByDay[day].checked ? false : true)}
                            />
                            <label className="form-check-label font-primary" htmlFor={`inlineCheck-${day}`}>
                              {props.t(day)}
                            </label>
                          </div>
                        </Col>
                        <Col className="col-8">
                          <MultiRangeSlider
                            disabled={!timesByDay[day].checked}
                            min={0}
                            max={24}
                            minValue={0}
                            step={1}
                            maxValue={24}
                            minCaption={
                              timesByDay[day].open === 0
                                ? "00h01"
                                : (timesByDay[day].open < 10 ? "0" + timesByDay[day].open : timesByDay[day].open) + "h"
                            }
                            maxCaption={
                              timesByDay[day].close < 10
                                ? "0" + timesByDay[day].close + "h"
                                : timesByDay[day].close === 24
                                ? props.t("23h59")
                                : timesByDay[day].close + "h"
                            }
                            onChange={(e) => {
                              setTimesByDay((prevState) => {
                                return {
                                  ...prevState,
                                  [day]: {
                                    ...prevState[day],
                                    open: e.minValue,
                                    close: e.maxValue,
                                  },
                                };
                              });
                            }}
                            onInput={(e) => {
                              setTimesByDay((prevState) => {
                                return {
                                  ...prevState,
                                  [day]: {
                                    ...prevState[day],
                                    open: e.minValue,
                                    close: e.maxValue,
                                  },
                                };
                              });
                            }}
                            style={{
                              border: "none",
                              boxShadow: "none",
                              background: "#F7F8FB",
                              padding: "20px 20px",
                            }}
                            labels={["", ""]}
                            ruler={false}
                            barLeftColor="#F7F8FB"
                            barInnerColor="#563BFF"
                            barRightColor="#F7F8FB"
                            thumbLeftColor="white"
                            thumbRightColor="white"
                          />
                        </Col>
                      </Row>
                    ))}
                  </Col>
                </Row>

                {Object.keys(formErrors).length > 0 && (
                  <div className="alert alert-danger">
                    {Object.keys(formErrors).map((day, index) => (
                      <p className="font-primary" key={index}>{`${props.t(day)}: ${formErrors[day]}`}</p>
                    ))}
                  </div>
                )}
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end" style={{ width: "100%" }}>
              <button type="button" className="view-button " style={{ color: "black", width: "100%" }} onClick={togAddAgentModal}>
                {props.t("Fermer")}
              </button>
              <button
                type="button"
                disabled={!agentModalInfo.agent_name && agentModalInfo.agent_language.length === 0}
                className="view-button addAgent-button"
                style={{
                  cursor: agentModalInfo.agent_name === "" || agentModalInfo.agent_language.length === 0 ? "not-allowed" : "pointer",
                  width: "100%",
                }}
                id="edit-btn"
                onClick={() => {
                  if (agentModalInfo.agent_language.length > 0) {
                    handleAgentAdded();
                  }
                }}>
                {updateAgentsLoading ? (
                  <span className="spinner-border spinner-border-sm me-2 font-primary" role="status" aria-hidden="true" />
                ) : (
                  props.t("Enregistrer")
                )}
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal> */}
      {/* Update agent Modal */}
      {/* <Modal isOpen={updateAgentModal} toggle={togUpdateAgentModal} centered>
        <ModalHeader className="bg-light p-3" id="exampleModalLabel" toggle={togUpdateAgentModal}>
          {props.t("MODIFIER AGENT")}
        </ModalHeader>
        <form className="tablelist-form" onSubmit={(e) => e.preventDefault()}>
          <ModalBody>
            <h6 className="font-tertiary font-size-16 font-primary" style={{ fontSize: "14px" }}>
              {props.t("Agent")}
            </h6>
            <Card style={{ boxShadow: "none" }}>
              <CardBody className="pb-0">
                <Row className="mb-4">
                  <Col md={12}>
                    <div>
                      <label className="font-primary" style={{ fontSize: "14px" }}>
                        {props.t("Nom de l'agent")}
                      </label>
                      <input
                        className="form-control font-primary simple-text"
                        type="text"
                        placeholder=" "
                        // disabled={true}
                        required
                        value={agentModalInfo.agent_name}
                        onChange={(e) =>
                          setAgentModalInfo({
                            ...agentModalInfo,
                            agent_name: e.target.value,
                          })
                        }
                      />
                    </div>
                  </Col>
                </Row>
                <Row className="my-4">
                  <Col md={12}>
                    <div>
                      <div>
                        <label className="font-primary" style={{ fontSize: "14px" }}>
                          {`${props.t("Langue de l'agent")} (${agentModalInfo.agent_language.length}/${numberOfLanguages})`}
                        </label>
                        {numberOfLanguages === agentModalInfo.agent_language.length && (
                          <div
                            onClick={onShowCalculator}
                            className="font-size-12"
                            style={{ float: "right", color: "rgb(86, 59, 255)", cursor: "pointer" }}>
                            {props.t("Upgrade to get more")}
                          </div>
                        )}
                      </div>

                      <div className="mb-3 templating-select select2-container">
                        <Select
                          // isOptionDisabled={(option, selectValue) => {
                          //   return true;
                          // }}
                          // isDisabled={numberOfLanguages === agentModalInfo.agent_language.length}
                          closeMenuOnSelect={numberOfLanguages === agentModalInfo.agent_language.length}
                          styles={{
                            option: (provided, state) => ({
                              ...provided,
                              cursor: numberOfLanguages === agentModalInfo.agent_language.length ? "not-allowed" : "pointer",
                              backgroundColor: "transparent",
                            }),
                          }}
                          style={{ zIndex: "9999" }}
                          value={agentModalInfo.agent_language.map((lang) => {
                            return {
                              label: props.t(lang.name),
                              value: lang.code,
                            };
                          })}
                          isMulti={true}
                          onChange={(e) => {
                            if (numberOfLanguages > agentModalInfo.agent_language.length || e.length <= numberOfLanguages) {
                              setAgentModalInfo({
                                ...agentModalInfo,
                                agent_language: e.map((lang) => {
                                  return { name: lang.label, code: lang.value };
                                }),
                              });
                            }
                          }}
                          placeholder={props.t("Select") + "..."}
                          options={optionGroup2.map((lang) => {
                            return {
                              label: props.t(lang.label),
                              value: lang.value,
                            };
                          })}
                          classNamePrefix="select2-selection"
                          // components={animatedComponents}
                        />
                        {agentModalInfo.agent_language.length === 0 && (
                          <span className="font-size-12" style={{ color: "red" }}>
                            {props.t("Vous devez sélectionner au moins une langue pour Synibox.")}
                          </span>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                <Col md={12} className="mb-4">
                  <label className="font-primary" style={{ fontSize: "14px" }}>
                    {props.t("Horaires d'activité de l'agent")}
                  </label>
                  <div className="form-floating mb-3">
                    <select
                      className="form-select form-control font-primary"
                      id="floatingSelectGrid"
                      aria-label="Floating label select example"
                      value={agentSelectedTimezone}
                      onChange={(e) => setAgentTimezone(setUtc(e.target.value))}>
                      <option value={agentSelectedTimezone}>{agentSelectedTimezone}</option>
                      {timezones.map((timezone, index) => (
                        <option key={index} value={timezone}>
                          {setUtc(timezone)}
                        </option>
                      ))}
                    </select>
                    <label htmlFor="floatingSelectGrid">
                      <p className="font-primary">
                        {props.t("Fuseau sélectionné")}: {agentSelectedTimezone}
                      </p>
                    </label>
                  </div>
                </Col>
                <Row>
                  <FormGroup className="mb-4">
                    <div className="d-flex align-items-center flex-wrap gap-2">
                      <input
                        type="checkbox"
                        style={{
                          backgroundColor: fullTime ? "#05B714" : "",
                          borderColor: fullTime ? "#05B714" : "",
                          fontSize: "14px",
                        }}
                        className="form-check-input"
                        id={"fulltime"}
                        name={"fulltime"}
                        value={fullTime}
                        defaultChecked={fullTime}
                        onChange={(e) => {
                          setFullTime(e.target.checked);
                          setTimesByDay({
                            week: {
                              open: 0,
                              close: 24,
                            },
                            week_end: {
                              open: 0,
                              close: 24,
                            },
                          });
                        }}
                      />
                      <div>
                        <span
                          style={{
                            color: "#171C1B",
                            fontFamily: "Poppins,sans-serif",
                            fontSize: "14px",
                            fontStyle: "normal",
                            fontWeight: 600,
                            lineHeight: "normal",
                          }}>
                          {props.t("full_time_ia_checkbox")}
                        </span>
                      </div>
                    </div>
                  </FormGroup>
                  {!fullTime && (
                    <Col md={12}>
                      {daysOfWeek.map((day, index) => (
                        <Row key={day} className="mb-3">
                          <Col className="col-4">
                            <div style={{ marginTop: "13px" }} key={index} className="form-check mb-3 d-flex align-items-center gap-1">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue={timesByDay[day].checked}
                                id={`inlineCheck-${day}`}
                                value={timesByDay[day].checked}
                                onClick={() => handleTimeChange(day, "checked", timesByDay[day].checked ? false : true)}
                              />
                              <label className="form-check-label font-primary" htmlFor={`inlineCheck-${day}`}>
                                {props.t(day)}
                              </label>
                            </div>
                          </Col>
                          <Col className="col-8 font-primary">
                            <MultiRangeSlider
                              disabled={!timesByDay[day].checked || !isUserPlanActive}
                              step={1}
                              min={0}
                              max={24}
                              //max={24}
                              minValue={timesByDay[day].open}
                              maxValue={timesByDay[day].close}
                              minCaption={
                                timesByDay[day].open === 0
                                  ? "00h01"
                                  : (timesByDay[day].open < 10 ? "0" + timesByDay[day].open : timesByDay[day].open) + "h"
                              }
                              maxCaption={
                                timesByDay[day].close < 10
                                  ? "0" + timesByDay[day].close + "h"
                                  : timesByDay[day].close === 24
                                  ? props.t("23h59")
                                  : timesByDay[day].close + "h"
                              }
                              onChange={(e) => {
                                setTimesByDay((prevState) => {
                                  return {
                                    ...prevState,
                                    [day]: {
                                      ...prevState[day],
                                      open: e.minValue,
                                      close: e.maxValue,
                                    },
                                  };
                                });
                              }}
                              onInput={(e) => {
                                setTimesByDay((prevState) => {
                                  return {
                                    ...prevState,
                                    [day]: {
                                      ...prevState[day],
                                      open: e.minValue,
                                      close: e.maxValue,
                                    },
                                  };
                                });
                              }}
                              style={{
                                border: "none",
                                boxShadow: "none",
                                background: "#F7F8FB",
                                padding: "20px 20px",
                              }}
                              labels={["", ""]}
                              ruler={false}
                              barLeftColor="#F7F8FB"
                              barInnerColor="#563BFF"
                              barRightColor="#F7F8FB"
                              thumbLeftColor="white"
                              thumbRightColor="white"
                            />
                          </Col>
                        </Row>
                      ))}
                    </Col>
                  )}
                </Row>

                {Object.keys(formErrors).length > 0 && (
                  <div className="alert alert-danger">
                    {Object.keys(formErrors).map((day, index) => (
                      <p key={index}>{`${props.t(day)}: ${formErrors[day]}`}</p>
                    ))}
                  </div>
                )}
              </CardBody>
            </Card>
          </ModalBody>
          <ModalFooter>
            <div className="hstack gap-2 justify-content-end" style={{ width: "100%" }}>
              <button type="button" className="view-button " onClick={togUpdateAgentModal} style={{ color: "black", width: "100%" }}>
                {props.t("Fermer")}
              </button>
              <button
                type="button"
                disabled={!agentModalInfo.agent_name && agentModalInfo.agent_language.length === 0}
                className="view-button addAgent-button"
                style={{
                  backgroundColor: "#563bff",
                  cursor: agentModalInfo.agent_name === "" || agentModalInfo.agent_language.length === 0 ? "not-allowed" : "pointer",
                  width: "100%",
                }}
                id="edit-btn"
                onClick={(e) => {
                  if (agentModalInfo.agent_language.length > 0) {
                    handleModalAgentUpdate(agentModalInfo.id);
                  }
                }}>
                {updateAgentLoading ? (
                  <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                ) : (
                  props.t("Enregistrer")
                )}
              </button>
            </div>
          </ModalFooter>
        </form>
      </Modal> */}
    </React.Fragment>
  );
};

export default withTranslation()(Settings);
